// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client'
import { client } from './client.gen'
import type {
  AcceptCostEstimateData,
  AcceptCostEstimateErrors,
  AcceptCostEstimateResponses,
  AcceptOnboardingCostEstimateData,
  AcceptOnboardingCostEstimateErrors,
  AcceptOnboardingCostEstimateResponses,
  AcknowledgeFinancialAidApprovalData,
  AcknowledgeFinancialAidApprovalErrors,
  AcknowledgeFinancialAidApprovalResponses,
  AcknowledgeRedFlagApprovalData,
  AcknowledgeRedFlagApprovalErrors,
  AcknowledgeRedFlagApprovalResponses,
  AcknowledgeWaitlistMatchData,
  AcknowledgeWaitlistMatchErrors,
  AcknowledgeWaitlistMatchResponses,
  ActionItemByIdData,
  ActionItemByIdErrors,
  ActionItemByIdResponses,
  ActionItemReferrerOptionsData,
  ActionItemReferrerOptionsErrors,
  ActionItemReferrerOptionsResponses,
  ActionItemsData,
  ActionItemsErrors,
  ActionItemsResponses,
  AdvanceOnboardingMilestoneData,
  AdvanceOnboardingMilestoneErrors,
  AdvanceOnboardingMilestoneResponses,
  AppointmentAssessmentAdministrationsData,
  AppointmentAssessmentAdministrationsErrors,
  AppointmentAssessmentAdministrationsResponses,
  AppointmentChartNoteData,
  AppointmentChartNoteErrors,
  AppointmentChartNoteResponses,
  ArchiveWheelhouseNoteTemplateData,
  ArchiveWheelhouseNoteTemplateErrors,
  ArchiveWheelhouseNoteTemplateResponses,
  AssessmentAssignmentData,
  AssessmentAssignmentErrors,
  AssessmentAssignmentResponses,
  AssessmentAudienceOptionsData,
  AssessmentAudienceOptionsErrors,
  AssessmentAudienceOptionsResponses,
  AssessmentDefinitionByIdData,
  AssessmentDefinitionByIdErrors,
  AssessmentDefinitionByIdResponses,
  AssessmentDefinitionsData,
  AssessmentDefinitionsErrors,
  AssessmentDefinitionsResponses,
  AssignTaskData,
  AssignTaskErrors,
  AssignTaskResponses,
  BackToSchoolReviewBannerData,
  BackToSchoolReviewBannerResponses,
  BrowserCallTokenData,
  BrowserCallTokenErrors,
  BrowserCallTokenResponses,
  BulkDeleteClinicianAppointmentsData,
  BulkDeleteClinicianAppointmentsErrors,
  BulkDeleteClinicianAppointmentsResponses,
  CalendarAppointmentsData,
  CalendarAppointmentsErrors,
  CalendarAppointmentsResponses,
  CalendarAppointmentVideoLinkData,
  CalendarAppointmentVideoLinkErrors,
  CalendarAppointmentVideoLinkResponses,
  CallByIdData,
  CallByIdErrors,
  CallByIdResponses,
  CallsData,
  CallsErrors,
  CallsResponses,
  CareOpsQaSpotChecksData,
  CareOpsQaSpotChecksErrors,
  CareOpsQaSpotChecksResponses,
  CareProgramsData,
  CareProgramsResponses,
  ChartNoteClinicalQualityScoresData,
  ChartNoteClinicalQualityScoresErrors,
  ChartNoteClinicalQualityScoresResponses,
  ClaimTaskData,
  ClaimTaskErrors,
  ClaimTaskResponses,
  ClearReferralDraftData,
  ClearReferralDraftErrors,
  ClearReferralDraftResponses,
  ClientAppointmentSummaryData,
  ClientAppointmentSummaryErrors,
  ClientAppointmentSummaryResponses,
  ClientAppointmentsData,
  ClientAppointmentsErrors,
  ClientAppointmentsResponses,
  ClientAssessmentResultsData,
  ClientAssessmentResultsErrors,
  ClientAssessmentResultsResponses,
  ClientAssessmentSendOptionsData,
  ClientAssessmentSendOptionsErrors,
  ClientAssessmentSendOptionsResponses,
  ClientBrooklineEvaluationConsentData,
  ClientBrooklineEvaluationConsentErrors,
  ClientBrooklineEvaluationConsentResponses,
  ClientByIdData,
  ClientByIdErrors,
  ClientByIdResponses,
  ClientCareProgramMembershipData,
  ClientCareProgramMembershipResponses,
  ClientCcbhoEncounterAttestationData,
  ClientCcbhoEncounterAttestationErrors,
  ClientCcbhoEncounterAttestationResponses,
  ClientChartNotesData,
  ClientChartNotesErrors,
  ClientChartNotesResponses,
  ClientClinicalDigestData,
  ClientClinicalDigestErrors,
  ClientClinicalDigestResponses,
  ClientCommunicationRecipientsData,
  ClientCommunicationRecipientsErrors,
  ClientCommunicationRecipientsResponses,
  ClientCostEstimateCreateData,
  ClientCostEstimateCreateErrors,
  ClientCostEstimateCreateResponses,
  ClientCostEstimateSendToFamilyData,
  ClientCostEstimateSendToFamilyErrors,
  ClientCostEstimateSendToFamilyResponses,
  ClientCostEstimateShowData,
  ClientCostEstimateShowErrors,
  ClientCostEstimateShowResponses,
  ClientCostEstimateSyncInsuranceDataData,
  ClientCostEstimateSyncInsuranceDataErrors,
  ClientCostEstimateSyncInsuranceDataResponses,
  ClientCostEstimateSyncStatusData,
  ClientCostEstimateSyncStatusErrors,
  ClientCostEstimateSyncStatusResponses,
  ClientCostEstimateUpdateData,
  ClientCostEstimateUpdateErrors,
  ClientCostEstimateUpdateResponses,
  ClientEventsData,
  ClientEventsErrors,
  ClientEventsResponses,
  ClientForthcomingAppointmentData,
  ClientForthcomingAppointmentErrors,
  ClientForthcomingAppointmentResponses,
  ClientInfoUpdateScheduleData,
  ClientInfoUpdateScheduleErrors,
  ClientInfoUpdateScheduleResponses,
  ClientInsuranceScansData,
  ClientInsuranceScansErrors,
  ClientInsuranceScansResponses,
  ClientNotificationsData,
  ClientNotificationsErrors,
  ClientNotificationsResponses,
  ClientPayerFormDataData,
  ClientPayerFormDataErrors,
  ClientPayerFormDataResponses,
  ClientProcessWorkflowData,
  ClientProcessWorkflowErrors,
  ClientProcessWorkflowResponses,
  ClientProcessWorkflowsData,
  ClientProcessWorkflowsErrors,
  ClientProcessWorkflowsResponses,
  ClientProfileData,
  ClientProfileErrors,
  ClientProfileResponses,
  ClientSessionLimitData,
  ClientSessionLimitErrors,
  ClientSessionLimitResponses,
  ClientSurveyResultsData,
  ClientSurveyResultsErrors,
  ClientSurveyResultsResponses,
  ClinicalQualityDashboardScoresData,
  ClinicalQualityDashboardScoresErrors,
  ClinicalQualityDashboardScoresResponses,
  ClinicalQualityDashboardSummaryData,
  ClinicalQualityDashboardSummaryErrors,
  ClinicalQualityDashboardSummaryResponses,
  ClinicalQualityScoreData,
  ClinicalQualityScoreErrors,
  ClinicalQualityScoreResponses,
  ClinicianAppointmentsData,
  ClinicianAppointmentsErrors,
  ClinicianAppointmentsResponses,
  ClinicianByIdData,
  ClinicianByIdErrors,
  ClinicianByIdResponses,
  ClinicianCalendarAppointmentsData,
  ClinicianCalendarAppointmentsErrors,
  ClinicianCalendarAppointmentsResponses,
  ClinicianChartNotesData,
  ClinicianChartNotesErrors,
  ClinicianChartNotesResponses,
  ClinicianMatchDiagnosisData,
  ClinicianMatchDiagnosisResponses,
  ClinicianMatchingCandidatePoolData,
  ClinicianMatchingCandidatePoolErrors,
  ClinicianMatchingCandidatePoolResponses,
  ClinicianMatchingIntakeOutcomesData,
  ClinicianMatchingIntakeOutcomesErrors,
  ClinicianMatchingIntakeOutcomesResponses,
  ClinicianMatchingOverviewData,
  ClinicianMatchingOverviewResponses,
  ClinicianMatchRunsData,
  ClinicianMatchRunsErrors,
  ClinicianMatchRunsResponses,
  ClinicianMatchRunsSummaryData,
  ClinicianMatchRunsSummaryErrors,
  ClinicianMatchRunsSummaryResponses,
  ClinicianReassignmentFormDataData,
  ClinicianReassignmentFormDataErrors,
  ClinicianReassignmentFormDataResponses,
  ClinicianSelectedMatchesData,
  ClinicianSelectedMatchesErrors,
  ClinicianSelectedMatchesResponses,
  CommentOnActionItemData,
  CommentOnActionItemErrors,
  CommentOnActionItemResponses,
  CommsPlaygroundCommsMapData,
  CommsPlaygroundCommsMapErrors,
  CommsPlaygroundCommsMapResponses,
  CommsPlaygroundEventsData,
  CommsPlaygroundEventsErrors,
  CommsPlaygroundEventsResponses,
  CommsPlaygroundTriggerEventData,
  CommsPlaygroundTriggerEventErrors,
  CommsPlaygroundTriggerEventResponses,
  CommsPlaygroundUserCommsData,
  CommsPlaygroundUserCommsErrors,
  CommsPlaygroundUserCommsResponses,
  CompleteTaskData,
  CompleteTaskErrors,
  CompleteTaskResponses,
  CompleteWheelhouseNoteData,
  CompleteWheelhouseNoteErrors,
  CompleteWheelhouseNoteResponses,
  ConcernTypesData,
  ConcernTypesResponses,
  ConversationByIdData,
  ConversationByIdErrors,
  ConversationByIdResponses,
  ConversationsData,
  ConversationsErrors,
  ConversationsResponses,
  CostEstimateData,
  CostEstimateErrors,
  CostEstimateResponses,
  CreateAppointmentChartNoteData,
  CreateAppointmentChartNoteErrors,
  CreateAppointmentChartNoteResponses,
  CreateAssessmentDefinitionData,
  CreateAssessmentDefinitionErrors,
  CreateAssessmentDefinitionResponses,
  CreateAssessmentManualSendData,
  CreateAssessmentManualSendErrors,
  CreateAssessmentManualSendResponses,
  CreateAutomatedOutreachData,
  CreateAutomatedOutreachErrors,
  CreateAutomatedOutreachResponses,
  CreateClientDirectUploadData,
  CreateClientDirectUploadErrors,
  CreateClientDirectUploadResponses,
  CreateClientEligibilityData,
  CreateClientEligibilityErrors,
  CreateClientEligibilityResponses,
  CreateClientEventData,
  CreateClientEventErrors,
  CreateClientEventResponses,
  CreateClientInsuranceScanData,
  CreateClientInsuranceScanErrors,
  CreateClientInsuranceScanResponses,
  CreateClientProcessWorkflowData,
  CreateClientProcessWorkflowErrors,
  CreateClientProcessWorkflowResponses,
  CreateContractUtilizationFeedbackData,
  CreateContractUtilizationFeedbackErrors,
  CreateContractUtilizationFeedbackResponses,
  CreateJourneyAvailabilityNoteData,
  CreateJourneyAvailabilityNoteErrors,
  CreateJourneyAvailabilityNoteResponses,
  CreateJourneySchedulingDeferralData,
  CreateJourneySchedulingDeferralErrors,
  CreateJourneySchedulingDeferralResponses,
  CreateMessageData,
  CreateMessageErrors,
  CreateMessageResponses,
  CreateOnboardingInsuranceScanData,
  CreateOnboardingInsuranceScanErrors,
  CreateOnboardingInsuranceScanResponses,
  CreateOnboardingJourneyBookingData,
  CreateOnboardingJourneyBookingErrors,
  CreateOnboardingJourneyBookingResponses,
  CreateOnboardingMatchingJourneyData,
  CreateOnboardingMatchingJourneyErrors,
  CreateOnboardingMatchingJourneyResponses,
  CreateOnboardingPaymentMethodSetupIntentData,
  CreateOnboardingPaymentMethodSetupIntentErrors,
  CreateOnboardingPaymentMethodSetupIntentResponses,
  CreateReassignmentData,
  CreateReassignmentErrors,
  CreateReassignmentResponses,
  CreateReferralData,
  CreateReferralErrors,
  CreateReferralResponses,
  CreateReferrerTourCompletionData,
  CreateReferrerTourCompletionErrors,
  CreateReferrerTourCompletionResponses,
  CreateSchedulingBookingData,
  CreateSchedulingBookingErrors,
  CreateSchedulingBookingResponses,
  CreateSurveyData,
  CreateSurveyErrors,
  CreateSurveyResponses,
  CreateTaskNoteData,
  CreateTaskNoteErrors,
  CreateTaskNoteResponses,
  CreateWheelhouseDocumentData,
  CreateWheelhouseDocumentErrors,
  CreateWheelhouseDocumentResponses,
  CreateWheelhouseEncounterData,
  CreateWheelhouseEncounterErrors,
  CreateWheelhouseEncounterResponses,
  CreateWheelhouseGoalData,
  CreateWheelhouseGoalObservationData,
  CreateWheelhouseGoalObservationErrors,
  CreateWheelhouseGoalObservationResponses,
  CreateWheelhouseGoalResponses,
  CreateWheelhouseNoteData,
  CreateWheelhouseNoteErrors,
  CreateWheelhouseNoteResponses,
  CreateWheelhouseNoteTemplateData,
  CreateWheelhouseNoteTemplateErrors,
  CreateWheelhouseNoteTemplateResponses,
  CurrentUserAhoyEventExistsData,
  CurrentUserAhoyEventExistsErrors,
  CurrentUserAhoyEventExistsResponses,
  CurrentUserData,
  CurrentUserErrors,
  CurrentUserProfileData,
  CurrentUserProfileErrors,
  CurrentUserProfileResponses,
  CurrentUserResponses,
  DashboardContractOverviewData,
  DashboardContractOverviewErrors,
  DashboardContractOverviewResponses,
  DecideClinicalReauthorizationData,
  DecideClinicalReauthorizationErrors,
  DecideClinicalReauthorizationResponses,
  DecideReauthorizationData,
  DecideReauthorizationErrors,
  DecideReauthorizationResponses,
  DeclineCostEstimateData,
  DeclineCostEstimateErrors,
  DeclineCostEstimateResponses,
  DeclineInternalReferralData,
  DeclineInternalReferralErrors,
  DeclineInternalReferralResponses,
  DeleteSurveyData,
  DeleteSurveyErrors,
  DeleteSurveyResponses,
  DeleteWheelhouseNoteData,
  DeleteWheelhouseNoteErrors,
  DeleteWheelhouseNoteResponses,
  DischargeClientFromCareProgramData,
  DischargeClientFromCareProgramErrors,
  DischargeClientFromCareProgramResponses,
  DismissBackToSchoolReviewBannerData,
  DismissBackToSchoolReviewBannerResponses,
  DismissProductAnnouncementData,
  DismissProductAnnouncementErrors,
  DismissProductAnnouncementResponses,
  EnhanceWheelhouseNoteData,
  EnhanceWheelhouseNoteErrors,
  EnhanceWheelhouseNoteResponses,
  EnrollClientInCareProgramData,
  EnrollClientInCareProgramErrors,
  EnrollClientInCareProgramResponses,
  FamilyInterestContextData,
  FamilyInterestContextErrors,
  FamilyInterestContextResponses,
  FamilyInterestDraftData,
  FamilyInterestDraftErrors,
  FamilyInterestDraftResponses,
  FamilyInterestFeaturedCliniciansData,
  FamilyInterestFeaturedCliniciansErrors,
  FamilyInterestFeaturedCliniciansResponses,
  FamilyInterestInstitutionsData,
  FamilyInterestInstitutionsErrors,
  FamilyInterestInstitutionsResponses,
  GetBackToSchoolReviewsData,
  GetBackToSchoolReviewsErrors,
  GetBackToSchoolReviewsReferrersData,
  GetBackToSchoolReviewsReferrersResponses,
  GetBackToSchoolReviewsResponses,
  GetBackToSchoolReviewsSchoolsBySchoolIdGradesData,
  GetBackToSchoolReviewsSchoolsBySchoolIdGradesResponses,
  GetBackToSchoolReviewsSchoolsData,
  GetBackToSchoolReviewsSchoolsResponses,
  GetCurrentClientData,
  GetCurrentClientErrors,
  GetCurrentClientResponses,
  InternalReferralByIdData,
  InternalReferralByIdErrors,
  InternalReferralByIdResponses,
  JoinClientForthcomingAppointmentData,
  JoinClientForthcomingAppointmentErrors,
  JoinClientForthcomingAppointmentResponses,
  JourneySchedulingInfoData,
  JourneySchedulingInfoErrors,
  JourneySchedulingInfoResponses,
  JourneySlotsData,
  JourneySlotsErrors,
  JourneySlotsResponses,
  KustomerProfileData,
  KustomerProfileErrors,
  KustomerProfileResponses,
  MeetingData,
  MeetingErrors,
  MeetingResponses,
  MessagesData,
  MessagesErrors,
  MessagesResponses,
  MyTasksData,
  MyTasksErrors,
  MyTasksResponses,
  OnboardingAddressData,
  OnboardingAddressErrors,
  OnboardingAddressResponses,
  OnboardingAvailabilitiesData,
  OnboardingAvailabilitiesResponses,
  OnboardingByIdData,
  OnboardingByIdErrors,
  OnboardingByIdResponses,
  OnboardingCompleteData,
  OnboardingCompleteErrors,
  OnboardingCompleteResponses,
  OnboardingConcernsData,
  OnboardingConcernsResponses,
  OnboardingConsentsData,
  OnboardingConsentsErrors,
  OnboardingConsentsResponses,
  OnboardingContextData,
  OnboardingContextErrors,
  OnboardingContextResponses,
  OnboardingCostEstimateData,
  OnboardingCostEstimateErrors,
  OnboardingCostEstimateResponses,
  OnboardingEligibilityStatusData,
  OnboardingEligibilityStatusErrors,
  OnboardingEligibilityStatusResponses,
  OnboardingFeaturedCliniciansData,
  OnboardingFeaturedCliniciansErrors,
  OnboardingFeaturedCliniciansResponses,
  OnboardingIdentityPreferencesData,
  OnboardingIdentityPreferencesResponses,
  OnboardingJointConsentsData,
  OnboardingJointConsentsErrors,
  OnboardingJointConsentsResponses,
  OnboardingMatchData,
  OnboardingMatchErrors,
  OnboardingMatchResponses,
  OnboardingMeetingPreferenceData,
  OnboardingMeetingPreferenceResponses,
  OnboardingPayersData,
  OnboardingPayersErrors,
  OnboardingPayersResponses,
  OnboardingServiceLinesData,
  OnboardingServiceLinesResponses,
  OnboardingSessionHeldData,
  OnboardingSessionHeldErrors,
  OnboardingSessionHeldResponses,
  OnboardingVerificationStatusData,
  OnboardingVerificationStatusErrors,
  OnboardingVerificationStatusResponses,
  OrganizationInstitutionsData,
  OrganizationInstitutionsErrors,
  OrganizationInstitutionsResponses,
  OrganizationStaffData,
  OrganizationStaffErrors,
  OrganizationStaffResponses,
  PayersData,
  PayersResponses,
  PollChartNoteClinicalQualityScoreData,
  PollChartNoteClinicalQualityScoreErrors,
  PollChartNoteClinicalQualityScoreResponses,
  PostBackToSchoolReviewsBatchUpdatesData,
  PostBackToSchoolReviewsBatchUpdatesResponses,
  PublishAssessmentVersionData,
  PublishAssessmentVersionErrors,
  PublishAssessmentVersionResponses,
  PublishClientClinicalDigestData,
  PublishClientClinicalDigestErrors,
  PublishClientClinicalDigestResponses,
  ReassignmentByIdData,
  ReassignmentByIdErrors,
  ReassignmentByIdResponses,
  ReassignmentsData,
  ReassignmentsErrors,
  ReassignmentsResponses,
  ReauthorizationEligibilityData,
  ReauthorizationEligibilityErrors,
  ReauthorizationEligibilityResponses,
  ReauthorizationReviewContextData,
  ReauthorizationReviewContextErrors,
  ReauthorizationReviewContextResponses,
  ReauthorizationReviewSummaryData,
  ReauthorizationReviewSummaryErrors,
  ReauthorizationReviewSummaryResponses,
  RecordCarrierLookupViewData,
  RecordCarrierLookupViewErrors,
  RecordCarrierLookupViewResponses,
  RecordClientBrooklineEvaluationConsentData,
  RecordClientBrooklineEvaluationConsentErrors,
  RecordClientBrooklineEvaluationConsentResponses,
  RecordClientCcbhoEncounterAttestationData,
  RecordClientCcbhoEncounterAttestationErrors,
  RecordClientCcbhoEncounterAttestationResponses,
  RecordClinicianJoinData,
  RecordClinicianJoinErrors,
  RecordClinicianJoinResponses,
  RecordContractUtilizationBadgeImpressionData,
  RecordContractUtilizationBadgeImpressionErrors,
  RecordContractUtilizationBadgeImpressionResponses,
  RecordContractUtilizationBadgeInteractionData,
  RecordContractUtilizationBadgeInteractionErrors,
  RecordContractUtilizationBadgeInteractionResponses,
  RecordCostConcernsSelectionData,
  RecordCostConcernsSelectionErrors,
  RecordCostConcernsSelectionResponses,
  RecordCostEstimateViewData,
  RecordCostEstimateViewErrors,
  RecordCostEstimateViewResponses,
  RecordFweCompletedData,
  RecordFweCompletedErrors,
  RecordFweCompletedResponses,
  RecordInsuranceNotVerifiedData,
  RecordInsuranceNotVerifiedErrors,
  RecordInsuranceNotVerifiedResponses,
  RecordJointConsentTaskEscalationOutcomeData,
  RecordJointConsentTaskEscalationOutcomeErrors,
  RecordJointConsentTaskEscalationOutcomeResponses,
  RecordNoInsuranceSelectionData,
  RecordNoInsuranceSelectionErrors,
  RecordNoInsuranceSelectionResponses,
  RecordSessionHeldEndFlowData,
  RecordSessionHeldEndFlowErrors,
  RecordSessionHeldEndFlowResponses,
  RecordTimeslotSelectedData,
  RecordTimeslotSelectedErrors,
  RecordTimeslotSelectedResponses,
  RecordWaitlistEndFlowData,
  RecordWaitlistEndFlowErrors,
  RecordWaitlistEndFlowResponses,
  RecordWaitlistRequestedData,
  RecordWaitlistRequestedErrors,
  RecordWaitlistRequestedResponses,
  ReferralDraftData,
  ReferralDraftErrors,
  ReferralDraftResponses,
  ReferralOnboardingProgressData,
  ReferralOnboardingProgressErrors,
  ReferralOnboardingProgressResponses,
  RejectWheelhouseClaimData,
  RejectWheelhouseClaimResponses,
  ReleaseTaskData,
  ReleaseTaskErrors,
  ReleaseTaskResponses,
  RequestFinancialAidData,
  RequestFinancialAidErrors,
  RequestFinancialAidResponses,
  RequestReassignmentSchedulingHelpData,
  RequestReassignmentSchedulingHelpErrors,
  RequestReassignmentSchedulingHelpResponses,
  ResetOrganizationReferralContactsData,
  ResetOrganizationReferralContactsErrors,
  ResetOrganizationReferralContactsResponses,
  ResolveActionItemData,
  ResolveActionItemErrors,
  ResolveActionItemResponses,
  ResolveClinicianMatchingIdData,
  ResolveClinicianMatchingIdResponses,
  RespondToSurveyData,
  RespondToSurveyErrors,
  RespondToSurveyResponses,
  SaveOnboardingAddressData,
  SaveOnboardingAddressErrors,
  SaveOnboardingAddressResponses,
  SaveOnboardingAvailabilitiesData,
  SaveOnboardingAvailabilitiesErrors,
  SaveOnboardingAvailabilitiesResponses,
  SaveOnboardingConcernsData,
  SaveOnboardingConcernsErrors,
  SaveOnboardingConcernsResponses,
  SaveOnboardingConsentsData,
  SaveOnboardingConsentsErrors,
  SaveOnboardingConsentsResponses,
  SaveOnboardingIdentityPreferencesData,
  SaveOnboardingIdentityPreferencesErrors,
  SaveOnboardingIdentityPreferencesResponses,
  SaveOnboardingJointConsentsData,
  SaveOnboardingJointConsentsErrors,
  SaveOnboardingJointConsentsResponses,
  SaveOnboardingMeetingPreferenceData,
  SaveOnboardingMeetingPreferenceErrors,
  SaveOnboardingMeetingPreferenceResponses,
  SaveOnboardingServiceLinesData,
  SaveOnboardingServiceLinesErrors,
  SaveOnboardingServiceLinesResponses,
  SaveSchedulingIdentityPreferencesData,
  SaveSchedulingIdentityPreferencesErrors,
  SaveSchedulingIdentityPreferencesResponses,
  SaveSchedulingMeetingPreferenceData,
  SaveSchedulingMeetingPreferenceErrors,
  SaveSchedulingMeetingPreferenceResponses,
  SchedulingClinicianMatchData,
  SchedulingClinicianMatchErrors,
  SchedulingClinicianMatchesData,
  SchedulingClinicianMatchesErrors,
  SchedulingClinicianMatchesResponses,
  SchedulingClinicianMatchResponses,
  SchedulingContextData,
  SchedulingContextErrors,
  SchedulingContextResponses,
  ScoreChartNoteClinicalQualityData,
  ScoreChartNoteClinicalQualityErrors,
  ScoreChartNoteClinicalQualityResponses,
  SearchClinicianMatchingClientsData,
  SearchClinicianMatchingClientsErrors,
  SearchClinicianMatchingClientsResponses,
  SearchClinicianMatchingCliniciansData,
  SearchClinicianMatchingCliniciansResponses,
  SignWheelhouseClaimData,
  SignWheelhouseClaimErrors,
  SignWheelhouseClaimResponses,
  SubmitAssessmentResponseData,
  SubmitAssessmentResponseErrors,
  SubmitAssessmentResponseResponses,
  SubmitFamilyInterestData,
  SubmitFamilyInterestErrors,
  SubmitFamilyInterestResponses,
  SubmitInsuranceZipCodeLookupData,
  SubmitInsuranceZipCodeLookupErrors,
  SubmitInsuranceZipCodeLookupResponses,
  SubmitOnboardingInsuranceData,
  SubmitOnboardingInsuranceErrors,
  SubmitOnboardingInsuranceResponses,
  SubmitOnboardingInsuranceSelfReportData,
  SubmitOnboardingInsuranceSelfReportErrors,
  SubmitOnboardingInsuranceSelfReportResponses,
  SubmitOnboardingSelfPayData,
  SubmitOnboardingSelfPayErrors,
  SubmitOnboardingSelfPayResponses,
  SubmitSurveyResponseCallbackData,
  SubmitSurveyResponseCallbackErrors,
  SubmitSurveyResponseCallbackResponses,
  SurveyByIdData,
  SurveyByIdErrors,
  SurveyByIdResponses,
  SurveyResponseByIdData,
  SurveyResponseByIdErrors,
  SurveyResponseByIdResponses,
  SurveyResponsesData,
  SurveyResponsesResponses,
  SurveySchemaByIdData,
  SurveySchemaByIdErrors,
  SurveySchemaByIdResponses,
  SurveySchemasData,
  SurveySchemasResponses,
  SurveysData,
  SurveysResponses,
  TaskByIdData,
  TaskByIdResponses,
  TaskEventsData,
  TaskEventsErrors,
  TaskEventsResponses,
  TaskInsuranceVerificationContextData,
  TaskInsuranceVerificationContextErrors,
  TaskInsuranceVerificationContextResponses,
  TaskReassignmentSchedulingContextData,
  TaskReassignmentSchedulingContextErrors,
  TaskReassignmentSchedulingContextResponses,
  TaskResolveMedicaidMcoMappingData,
  TaskResolveMedicaidMcoMappingErrors,
  TaskResolveMedicaidMcoMappingResponses,
  TaskResolveVerifyInsuranceData,
  TaskResolveVerifyInsuranceErrors,
  TaskResolveVerifyInsuranceResponses,
  TaskScheduleIntakeContextData,
  TaskScheduleIntakeContextErrors,
  TaskScheduleIntakeContextResponses,
  TaskSchedulingContextData,
  TaskSchedulingContextErrors,
  TaskSchedulingContextResponses,
  TasksData,
  TasksResponses,
  ToggleAssessmentAutoSendData,
  ToggleAssessmentAutoSendErrors,
  ToggleAssessmentAutoSendResponses,
  TrackCurrentUserAhoyEventData,
  TrackCurrentUserAhoyEventErrors,
  TrackCurrentUserAhoyEventResponses,
  TriggerClientInfoUpdateData,
  TriggerClientInfoUpdateErrors,
  TriggerClientInfoUpdateResponses,
  UnpublishClientClinicalDigestData,
  UnpublishClientClinicalDigestErrors,
  UnpublishClientClinicalDigestResponses,
  UpdateAssessmentDefinitionData,
  UpdateAssessmentDefinitionErrors,
  UpdateAssessmentDefinitionResponses,
  UpdateClientCareProgramMembershipData,
  UpdateClientCareProgramMembershipErrors,
  UpdateClientCareProgramMembershipResponses,
  UpdateClientInfoUpdateScheduleData,
  UpdateClientInfoUpdateScheduleErrors,
  UpdateClientInfoUpdateScheduleResponses,
  UpdateClientPayerData,
  UpdateClientPayerErrors,
  UpdateClientPayerResponses,
  UpdateClientSecondGuardianData,
  UpdateClientSecondGuardianErrors,
  UpdateClientSecondGuardianResponses,
  UpdateFamilyInterestDraftData,
  UpdateFamilyInterestDraftErrors,
  UpdateFamilyInterestDraftResponses,
  UpdateJourneySlotsData,
  UpdateJourneySlotsErrors,
  UpdateJourneySlotsResponses,
  UpdateReassignmentData,
  UpdateReassignmentErrors,
  UpdateReassignmentResponses,
  UpdateReferralDraftData,
  UpdateReferralDraftErrors,
  UpdateReferralDraftResponses,
  UpdateSchoolReferralContactData,
  UpdateSchoolReferralContactErrors,
  UpdateSchoolReferralContactResponses,
  UpdateSurveyData,
  UpdateSurveyErrors,
  UpdateSurveyResponses,
  UpdateUserPhoneNumberData,
  UpdateUserPhoneNumberErrors,
  UpdateUserPhoneNumberResponses,
  UpdateWheelhouseClaimData,
  UpdateWheelhouseClaimResponses,
  UpdateWheelhouseDocumentData,
  UpdateWheelhouseDocumentErrors,
  UpdateWheelhouseDocumentResponses,
  UpdateWheelhouseEncounterData,
  UpdateWheelhouseEncounterErrors,
  UpdateWheelhouseEncounterResponses,
  UpdateWheelhouseGoalData,
  UpdateWheelhouseGoalErrors,
  UpdateWheelhouseGoalObservationData,
  UpdateWheelhouseGoalObservationErrors,
  UpdateWheelhouseGoalObservationResponses,
  UpdateWheelhouseGoalResponses,
  UpdateWheelhouseNoteData,
  UpdateWheelhouseNoteErrors,
  UpdateWheelhouseNoteResponses,
  UpdateWheelhouseNoteTemplateData,
  UpdateWheelhouseNoteTemplateErrors,
  UpdateWheelhouseNoteTemplateResponses,
  UsersData,
  UsersErrors,
  UsersResponses,
  VerifyClientData,
  VerifyClientErrors,
  VerifyClientResponses,
  VerifyFamilyIdentityData,
  VerifyFamilyIdentityErrors,
  VerifyFamilyIdentityResponses,
  WheelhouseClaimData,
  WheelhouseClaimErrors,
  WheelhouseClaimResponses,
  WheelhouseClaimsData,
  WheelhouseClaimsResponses,
  WheelhouseClientData,
  WheelhouseClientDocumentsData,
  WheelhouseClientDocumentsErrors,
  WheelhouseClientDocumentsResponses,
  WheelhouseClientErrors,
  WheelhouseClientGoalsData,
  WheelhouseClientGoalsResponses,
  WheelhouseClientResponses,
  WheelhouseClientsData,
  WheelhouseClientsErrors,
  WheelhouseClientsResponses,
  WheelhouseDocumentData,
  WheelhouseDocumentErrors,
  WheelhouseDocumentResponses,
  WheelhouseEncounterData,
  WheelhouseEncounterErrors,
  WheelhouseEncounterResponses,
  WheelhouseEncountersData,
  WheelhouseEncountersErrors,
  WheelhouseEncountersResponses,
  WheelhouseGoalData,
  WheelhouseGoalErrors,
  WheelhouseGoalObservationsData,
  WheelhouseGoalObservationsResponses,
  WheelhouseGoalResponses,
  WheelhouseNoteTemplatesData,
  WheelhouseNoteTemplatesErrors,
  WheelhouseNoteTemplatesResponses,
  WheelhouseSessionData,
  WheelhouseSessionErrors,
  WheelhouseSessionResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Lists action items for the user's organization
 */
export const actionItems = <ThrowOnError extends boolean = false>(
  options?: Options<ActionItemsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ActionItemsResponses, ActionItemsErrors, ThrowOnError>({
    url: '/v1/action_items',
    ...options,
  })

/**
 * Returns referrer filter options for the action items team view
 */
export const actionItemReferrerOptions = <ThrowOnError extends boolean = false>(
  options?: Options<ActionItemReferrerOptionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ActionItemReferrerOptionsResponses,
    ActionItemReferrerOptionsErrors,
    ThrowOnError
  >({ url: '/v1/action_items/referrer_options', ...options })

/**
 * Gets an action item by ID
 */
export const actionItemById = <ThrowOnError extends boolean = false>(
  options: Options<ActionItemByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<ActionItemByIdResponses, ActionItemByIdErrors, ThrowOnError>({
    url: '/v1/action_items/{id}',
    ...options,
  })

/**
 * Mark action item as resolved
 */
export const resolveActionItem = <ThrowOnError extends boolean = false>(
  options: Options<ResolveActionItemData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ResolveActionItemResponses,
    ResolveActionItemErrors,
    ThrowOnError
  >({ url: '/v1/action_items/{id}/resolve', ...options })

/**
 * Add a comment to an action item
 */
export const commentOnActionItem = <ThrowOnError extends boolean = false>(
  options: Options<CommentOnActionItemData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    CommentOnActionItemResponses,
    CommentOnActionItemErrors,
    ThrowOnError
  >({
    url: '/v1/action_items/{id}/add_comment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Checks whether the current user has an Ahoy event
 */
export const currentUserAhoyEventExists = <ThrowOnError extends boolean = false>(
  options: Options<CurrentUserAhoyEventExistsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    CurrentUserAhoyEventExistsResponses,
    CurrentUserAhoyEventExistsErrors,
    ThrowOnError
  >({ url: '/v1/ahoy_events/exists', ...options })

/**
 * Tracks an Ahoy event for the current user
 */
export const trackCurrentUserAhoyEvent = <ThrowOnError extends boolean = false>(
  options?: Options<TrackCurrentUserAhoyEventData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    TrackCurrentUserAhoyEventResponses,
    TrackCurrentUserAhoyEventErrors,
    ThrowOnError
  >({
    url: '/v1/ahoy_events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List assessments due and administerable for the appointment's client
 */
export const appointmentAssessmentAdministrations = <ThrowOnError extends boolean = false>(
  options: Options<AppointmentAssessmentAdministrationsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppointmentAssessmentAdministrationsResponses,
    AppointmentAssessmentAdministrationsErrors,
    ThrowOnError
  >({ url: '/v1/appointments/{appointment_id}/assessment_administrations', ...options })

/**
 * Fetch the chart-note resource (template + existing FAG, if any) for an appointment
 */
export const appointmentChartNote = <ThrowOnError extends boolean = false>(
  options: Options<AppointmentChartNoteData, ThrowOnError>
) =>
  (options.client ?? client).get<
    AppointmentChartNoteResponses,
    AppointmentChartNoteErrors,
    ThrowOnError
  >({ url: '/v1/appointments/{appointment_id}/chart_note', ...options })

/**
 * Create (or reuse) a Healthie chart note for an appointment
 */
export const createAppointmentChartNote = <ThrowOnError extends boolean = false>(
  options: Options<CreateAppointmentChartNoteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAppointmentChartNoteResponses,
    CreateAppointmentChartNoteErrors,
    ThrowOnError
  >({
    url: '/v1/appointments/{appointment_id}/chart_note',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Returns meeting data (session URLs, client Upheal id, eligibility)
 */
export const meeting = <ThrowOnError extends boolean = false>(
  options: Options<MeetingData, ThrowOnError>
) =>
  (options.client ?? client).get<MeetingResponses, MeetingErrors, ThrowOnError>({
    url: '/v1/appointments/{appointment_id}/meeting',
    ...options,
  })

/**
 * Records that the host clinician joined the native (pop-out) meeting
 */
export const recordClinicianJoin = <ThrowOnError extends boolean = false>(
  options: Options<RecordClinicianJoinData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordClinicianJoinResponses,
    RecordClinicianJoinErrors,
    ThrowOnError
  >({
    url: '/v1/appointments/{appointment_id}/meeting/join',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch a version-pinned assessment assignment
 */
export const assessmentAssignment = <ThrowOnError extends boolean = false>(
  options: Options<AssessmentAssignmentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    AssessmentAssignmentResponses,
    AssessmentAssignmentErrors,
    ThrowOnError
  >({ url: '/v1/assessments/assignments/{signed_id}', ...options })

/**
 * list assessment audience options
 */
export const assessmentAudienceOptions = <ThrowOnError extends boolean = false>(
  options?: Options<AssessmentAudienceOptionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AssessmentAudienceOptionsResponses,
    AssessmentAudienceOptionsErrors,
    ThrowOnError
  >({ url: '/v1/assessments/audience_options', ...options })

/**
 * list assessment definitions
 */
export const assessmentDefinitions = <ThrowOnError extends boolean = false>(
  options?: Options<AssessmentDefinitionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AssessmentDefinitionsResponses,
    AssessmentDefinitionsErrors,
    ThrowOnError
  >({ url: '/v1/assessments/definitions', ...options })

/**
 * create an assessment definition
 */
export const createAssessmentDefinition = <ThrowOnError extends boolean = false>(
  options?: Options<CreateAssessmentDefinitionData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateAssessmentDefinitionResponses,
    CreateAssessmentDefinitionErrors,
    ThrowOnError
  >({
    url: '/v1/assessments/definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * get an assessment definition by ID
 */
export const assessmentDefinitionById = <ThrowOnError extends boolean = false>(
  options: Options<AssessmentDefinitionByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    AssessmentDefinitionByIdResponses,
    AssessmentDefinitionByIdErrors,
    ThrowOnError
  >({ url: '/v1/assessments/definitions/{id}', ...options })

/**
 * update an assessment definition
 */
export const updateAssessmentDefinition = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAssessmentDefinitionData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateAssessmentDefinitionResponses,
    UpdateAssessmentDefinitionErrors,
    ThrowOnError
  >({
    url: '/v1/assessments/definitions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * send an assessment on request
 */
export const createAssessmentManualSend = <ThrowOnError extends boolean = false>(
  options?: Options<CreateAssessmentManualSendData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateAssessmentManualSendResponses,
    CreateAssessmentManualSendErrors,
    ThrowOnError
  >({
    url: '/v1/assessments/manual_sends',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Submit an assessment response
 */
export const submitAssessmentResponse = <ThrowOnError extends boolean = false>(
  options: Options<SubmitAssessmentResponseData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitAssessmentResponseResponses,
    SubmitAssessmentResponseErrors,
    ThrowOnError
  >({
    url: '/v1/assessments/assignments/{signed_id}/response',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * publish a new assessment version
 */
export const publishAssessmentVersion = <ThrowOnError extends boolean = false>(
  options: Options<PublishAssessmentVersionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PublishAssessmentVersionResponses,
    PublishAssessmentVersionErrors,
    ThrowOnError
  >({ url: '/v1/assessments/definitions/{definition_id}/versions', ...options })

/**
 * Starts automated outreach for a referral
 */
export const createAutomatedOutreach = <ThrowOnError extends boolean = false>(
  options?: Options<CreateAutomatedOutreachData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateAutomatedOutreachResponses,
    CreateAutomatedOutreachErrors,
    ThrowOnError
  >({
    url: '/v1/automated_outreaches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Lists back-to-school review rows
 */
export const getBackToSchoolReviews = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackToSchoolReviewsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetBackToSchoolReviewsResponses,
    GetBackToSchoolReviewsErrors,
    ThrowOnError
  >({ url: '/v1/back_to_school_reviews', ...options })

/**
 * Lists schools for back-to-school review
 */
export const getBackToSchoolReviewsSchools = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackToSchoolReviewsSchoolsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetBackToSchoolReviewsSchoolsResponses, unknown, ThrowOnError>({
    url: '/v1/back_to_school_reviews/schools',
    ...options,
  })

/**
 * Lists grades offered at a school
 */
export const getBackToSchoolReviewsSchoolsBySchoolIdGrades = <ThrowOnError extends boolean = false>(
  options: Options<GetBackToSchoolReviewsSchoolsBySchoolIdGradesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetBackToSchoolReviewsSchoolsBySchoolIdGradesResponses,
    unknown,
    ThrowOnError
  >({ url: '/v1/back_to_school_reviews/schools/{school_id}/grades', ...options })

/**
 * Lists referrers for back-to-school review
 */
export const getBackToSchoolReviewsReferrers = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackToSchoolReviewsReferrersData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetBackToSchoolReviewsReferrersResponses, unknown, ThrowOnError>({
    url: '/v1/back_to_school_reviews/referrers',
    ...options,
  })

/**
 * Returns back-to-school review banner status
 */
export const backToSchoolReviewBanner = <ThrowOnError extends boolean = false>(
  options?: Options<BackToSchoolReviewBannerData, ThrowOnError>
) =>
  (options?.client ?? client).get<BackToSchoolReviewBannerResponses, unknown, ThrowOnError>({
    url: '/v1/back_to_school_reviews/banner',
    ...options,
  })

/**
 * Dismisses the back-to-school review banner
 */
export const dismissBackToSchoolReviewBanner = <ThrowOnError extends boolean = false>(
  options?: Options<DismissBackToSchoolReviewBannerData, ThrowOnError>
) =>
  (options?.client ?? client).post<DismissBackToSchoolReviewBannerResponses, unknown, ThrowOnError>(
    { url: '/v1/back_to_school_reviews/banner/dismissal', ...options }
  )

/**
 * Batch updates back-to-school review rows
 */
export const postBackToSchoolReviewsBatchUpdates = <ThrowOnError extends boolean = false>(
  options?: Options<PostBackToSchoolReviewsBatchUpdatesData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    PostBackToSchoolReviewsBatchUpdatesResponses,
    unknown,
    ThrowOnError
  >({
    url: '/v1/back_to_school_reviews/batch_updates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Fetches the video call link for an appointment
 */
export const calendarAppointmentVideoLink = <ThrowOnError extends boolean = false>(
  options: Options<CalendarAppointmentVideoLinkData, ThrowOnError>
) =>
  (options.client ?? client).get<
    CalendarAppointmentVideoLinkResponses,
    CalendarAppointmentVideoLinkErrors,
    ThrowOnError
  >({ url: '/v1/calendar_appointments/{calendar_appointment_id}/video_link', ...options })

/**
 * Lists appointments for the month
 */
export const calendarAppointments = <ThrowOnError extends boolean = false>(
  options?: Options<CalendarAppointmentsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CalendarAppointmentsResponses,
    CalendarAppointmentsErrors,
    ThrowOnError
  >({ url: '/v1/calendar_appointments', ...options })

/**
 * list calls
 */
export const calls = <ThrowOnError extends boolean = false>(
  options?: Options<CallsData, ThrowOnError>
) =>
  (options?.client ?? client).get<CallsResponses, CallsErrors, ThrowOnError>({
    url: '/v1/calls',
    ...options,
  })

/**
 * create browser call token
 */
export const browserCallToken = <ThrowOnError extends boolean = false>(
  options?: Options<BrowserCallTokenData, ThrowOnError>
) =>
  (options?.client ?? client).post<BrowserCallTokenResponses, BrowserCallTokenErrors, ThrowOnError>(
    {
      url: '/v1/calls/browser_token',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    }
  )

/**
 * show call
 */
export const callById = <ThrowOnError extends boolean = false>(
  options: Options<CallByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<CallByIdResponses, CallByIdErrors, ThrowOnError>({
    url: '/v1/calls/{id}',
    ...options,
  })

/**
 * list team-wide flagged referrals for admin review
 */
export const careOpsQaSpotChecks = <ThrowOnError extends boolean = false>(
  options?: Options<CareOpsQaSpotChecksData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CareOpsQaSpotChecksResponses,
    CareOpsQaSpotChecksErrors,
    ThrowOnError
  >({ url: '/v1/care_ops_qa/spot_checks', ...options })

/**
 * list the care programs an organization can refer into
 *
 * Returns the active, enabled programs from the care program registry, ordered by name. Returns an empty list when :care_programs_platform_SEP_2026 is off for the organization, so callers can treat "out of cohort" and "nothing provisioned" identically.
 */
export const carePrograms = <ThrowOnError extends boolean = false>(
  options: Options<CareProgramsData, ThrowOnError>
) =>
  (options.client ?? client).get<CareProgramsResponses, unknown, ThrowOnError>({
    url: '/v1/care_programs',
    ...options,
  })

/**
 * list clinical quality scores for a chart note
 */
export const chartNoteClinicalQualityScores = <ThrowOnError extends boolean = false>(
  options: Options<ChartNoteClinicalQualityScoresData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ChartNoteClinicalQualityScoresResponses,
    ChartNoteClinicalQualityScoresErrors,
    ThrowOnError
  >({ url: '/v1/chart_notes/{chart_note_id}/clinical_quality_scores', ...options })

/**
 * enqueue clinical quality score job
 */
export const scoreChartNoteClinicalQuality = <ThrowOnError extends boolean = false>(
  options: Options<ScoreChartNoteClinicalQualityData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ScoreChartNoteClinicalQualityResponses,
    ScoreChartNoteClinicalQualityErrors,
    ThrowOnError
  >({ url: '/v1/chart_notes/{chart_note_id}/clinical_quality_scores', ...options })

/**
 * poll scoring job status
 */
export const pollChartNoteClinicalQualityScore = <ThrowOnError extends boolean = false>(
  options: Options<PollChartNoteClinicalQualityScoreData, ThrowOnError>
) =>
  (options.client ?? client).get<
    PollChartNoteClinicalQualityScoreResponses,
    PollChartNoteClinicalQualityScoreErrors,
    ThrowOnError
  >({ url: '/v1/chart_notes/{chart_note_id}/clinical_quality_scores/poll', ...options })

/**
 * list appointments for client
 */
export const clientAppointments = <ThrowOnError extends boolean = false>(
  options: Options<ClientAppointmentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientAppointmentsResponses,
    ClientAppointmentsErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/appointments', ...options })

/**
 * fetch appointments summary for client
 */
export const clientAppointmentSummary = <ThrowOnError extends boolean = false>(
  options: Options<ClientAppointmentSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientAppointmentSummaryResponses,
    ClientAppointmentSummaryErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/appointments/summary', ...options })

/**
 * list completed assessment results for client
 */
export const clientAssessmentResults = <ThrowOnError extends boolean = false>(
  options: Options<ClientAssessmentResultsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientAssessmentResultsResponses,
    ClientAssessmentResultsErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/assessment_results', ...options })

/**
 * list sendable assessments and auto-send opt-out state for a client
 */
export const clientAssessmentSendOptions = <ThrowOnError extends boolean = false>(
  options: Options<ClientAssessmentSendOptionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientAssessmentSendOptionsResponses,
    ClientAssessmentSendOptionsErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/assessment_send_options', ...options })

/**
 * toggle assessment auto-send opt-out for a client
 */
export const toggleAssessmentAutoSend = <ThrowOnError extends boolean = false>(
  options: Options<ToggleAssessmentAutoSendData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ToggleAssessmentAutoSendResponses,
    ToggleAssessmentAutoSendErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/assessment_send_options',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Brookline evaluation consent eligibility and current value
 */
export const clientBrooklineEvaluationConsent = <ThrowOnError extends boolean = false>(
  options: Options<ClientBrooklineEvaluationConsentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientBrooklineEvaluationConsentResponses,
    ClientBrooklineEvaluationConsentErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/brookline_evaluation_consent', ...options })

/**
 * Submit Brookline evaluation consent decision
 */
export const recordClientBrooklineEvaluationConsent = <ThrowOnError extends boolean = false>(
  options: Options<RecordClientBrooklineEvaluationConsentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordClientBrooklineEvaluationConsentResponses,
    RecordClientBrooklineEvaluationConsentErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/brookline_evaluation_consent',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * enroll a student in a care program
 *
 * Manually opens a care program episode from the student details page. Enrollment is exclusive: a student live in another program, or holding an active School Avoidance marker, is refused.
 */
export const enrollClientInCareProgram = <ThrowOnError extends boolean = false>(
  options: Options<EnrollClientInCareProgramData, ThrowOnError>
) =>
  (options.client ?? client).post<
    EnrollClientInCareProgramResponses,
    EnrollClientInCareProgramErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/care_program_enrollment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * end a student's care program episode
 *
 * Closes the student's live episode. The optional free-text note stays in Postgres and is never emitted on an event or returned here.
 */
export const dischargeClientFromCareProgram = <ThrowOnError extends boolean = false>(
  options: Options<DischargeClientFromCareProgramData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DischargeClientFromCareProgramResponses,
    DischargeClientFromCareProgramErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/care_program_enrollment/discharge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * read a student's care program membership
 *
 * Membership is a single slot: a registry care program, the School Avoidance marker, or nothing. Districts outside the :care_programs_platform_SEP_2026 cohort get an empty membership with no options and a 200, so a surface that opens on every appointment renders no control rather than an error.
 */
export const clientCareProgramMembership = <ThrowOnError extends boolean = false>(
  options: Options<ClientCareProgramMembershipData, ThrowOnError>
) =>
  (options.client ?? client).get<ClientCareProgramMembershipResponses, unknown, ThrowOnError>({
    url: '/v1/clients/{client_id}/care_program_membership',
    ...options,
  })

/**
 * change a student's care program membership
 *
 * Sets the student's single membership slot. Switching between a registry program and School Avoidance is one atomic swap — the incumbent slot is vacated and the target taken inside one transaction, so either half failing leaves the student where they started. Re-selecting the slot the student already holds is a no-op.
 */
export const updateClientCareProgramMembership = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClientCareProgramMembershipData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateClientCareProgramMembershipResponses,
    UpdateClientCareProgramMembershipErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/care_program_membership',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get CCBHO encounter attestation appointment context and signature status
 */
export const clientCcbhoEncounterAttestation = <ThrowOnError extends boolean = false>(
  options: Options<ClientCcbhoEncounterAttestationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientCcbhoEncounterAttestationResponses,
    ClientCcbhoEncounterAttestationErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/ccbho_encounter_attestations/{appointment_id}', ...options })

/**
 * Submit a CCBHO encounter attestation signature
 */
export const recordClientCcbhoEncounterAttestation = <ThrowOnError extends boolean = false>(
  options: Options<RecordClientCcbhoEncounterAttestationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordClientCcbhoEncounterAttestationResponses,
    RecordClientCcbhoEncounterAttestationErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/ccbho_encounter_attestations/{appointment_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list chart notes for client
 */
export const clientChartNotes = <ThrowOnError extends boolean = false>(
  options: Options<ClientChartNotesData, ThrowOnError>
) =>
  (options.client ?? client).get<ClientChartNotesResponses, ClientChartNotesErrors, ThrowOnError>({
    url: '/v1/clients/{client_id}/chart_notes',
    ...options,
  })

/**
 * fetch clinical digest for client
 */
export const clientClinicalDigest = <ThrowOnError extends boolean = false>(
  options: Options<ClientClinicalDigestData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientClinicalDigestResponses,
    ClientClinicalDigestErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/clinical_digest', ...options })

/**
 * publish clinical digest
 */
export const publishClientClinicalDigest = <ThrowOnError extends boolean = false>(
  options: Options<PublishClientClinicalDigestData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PublishClientClinicalDigestResponses,
    PublishClientClinicalDigestErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/clinical_digest/publish', ...options })

/**
 * unpublish clinical digest
 */
export const unpublishClientClinicalDigest = <ThrowOnError extends boolean = false>(
  options: Options<UnpublishClientClinicalDigestData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UnpublishClientClinicalDigestResponses,
    UnpublishClientClinicalDigestErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/clinical_digest/unpublish', ...options })

/**
 * list client communication recipients
 */
export const clientCommunicationRecipients = <ThrowOnError extends boolean = false>(
  options: Options<ClientCommunicationRecipientsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientCommunicationRecipientsResponses,
    ClientCommunicationRecipientsErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/communication_recipients', ...options })

/**
 * get the latest cost estimate for a client
 */
export const clientCostEstimateShow = <ThrowOnError extends boolean = false>(
  options: Options<ClientCostEstimateShowData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientCostEstimateShowResponses,
    ClientCostEstimateShowErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/cost_estimate', ...options })

/**
 * create a cost estimate for a client
 */
export const clientCostEstimateCreate = <ThrowOnError extends boolean = false>(
  options: Options<ClientCostEstimateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ClientCostEstimateCreateResponses,
    ClientCostEstimateCreateErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/cost_estimate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * update an existing cost estimate
 */
export const clientCostEstimateUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ClientCostEstimateUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ClientCostEstimateUpdateResponses,
    ClientCostEstimateUpdateErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/cost_estimate/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * send the cost estimate to the family via SMS
 */
export const clientCostEstimateSendToFamily = <ThrowOnError extends boolean = false>(
  options: Options<ClientCostEstimateSendToFamilyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ClientCostEstimateSendToFamilyResponses,
    ClientCostEstimateSendToFamilyErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/cost_estimate/{id}/send_to_family', ...options })

/**
 * enqueue an insurance-data sync job
 */
export const clientCostEstimateSyncInsuranceData = <ThrowOnError extends boolean = false>(
  options: Options<ClientCostEstimateSyncInsuranceDataData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ClientCostEstimateSyncInsuranceDataResponses,
    ClientCostEstimateSyncInsuranceDataErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/cost_estimate/sync_insurance_data', ...options })

/**
 * poll the insurance-data sync job status
 */
export const clientCostEstimateSyncStatus = <ThrowOnError extends boolean = false>(
  options: Options<ClientCostEstimateSyncStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientCostEstimateSyncStatusResponses,
    ClientCostEstimateSyncStatusErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/cost_estimate/sync_status', ...options })

/**
 * Create a direct upload
 */
export const createClientDirectUpload = <ThrowOnError extends boolean = false>(
  options: Options<CreateClientDirectUploadData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateClientDirectUploadResponses,
    CreateClientDirectUploadErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/direct_uploads',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create an eligibility check
 */
export const createClientEligibility = <ThrowOnError extends boolean = false>(
  options: Options<CreateClientEligibilityData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateClientEligibilityResponses,
    CreateClientEligibilityErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/eligibilities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List client events
 */
export const clientEvents = <ThrowOnError extends boolean = false>(
  options: Options<ClientEventsData, ThrowOnError>
) =>
  (options.client ?? client).get<ClientEventsResponses, ClientEventsErrors, ThrowOnError>({
    url: '/v1/clients/{client_id}/events',
    ...options,
  })

/**
 * Create a client event
 */
export const createClientEvent = <ThrowOnError extends boolean = false>(
  options: Options<CreateClientEventData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateClientEventResponses,
    CreateClientEventErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Returns appointment info for a client across all journeys
 */
export const clientForthcomingAppointment = <ThrowOnError extends boolean = false>(
  options: Options<ClientForthcomingAppointmentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientForthcomingAppointmentResponses,
    ClientForthcomingAppointmentErrors,
    ThrowOnError
  >({ url: '/v1/clients/{shareable_id}/forthcoming_appointment', ...options })

/**
 * Records client join and returns session URL
 */
export const joinClientForthcomingAppointment = <ThrowOnError extends boolean = false>(
  options: Options<JoinClientForthcomingAppointmentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    JoinClientForthcomingAppointmentResponses,
    JoinClientForthcomingAppointmentErrors,
    ThrowOnError
  >({ url: '/v1/clients/{shareable_id}/forthcoming_appointment/join', ...options })

/**
 * Get the latest recent insurance scan
 */
export const clientInsuranceScans = <ThrowOnError extends boolean = false>(
  options: Options<ClientInsuranceScansData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientInsuranceScansResponses,
    ClientInsuranceScansErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/insurance_scans', ...options })

/**
 * Create an insurance scan
 */
export const createClientInsuranceScan = <ThrowOnError extends boolean = false>(
  options: Options<CreateClientInsuranceScanData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateClientInsuranceScanResponses,
    CreateClientInsuranceScanErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/insurance_scans',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list recent client notifications
 */
export const clientNotifications = <ThrowOnError extends boolean = false>(
  options: Options<ClientNotificationsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientNotificationsResponses,
    ClientNotificationsErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/notifications', ...options })

/**
 * get form data for client payers
 */
export const clientPayerFormData = <ThrowOnError extends boolean = false>(
  options: Options<ClientPayerFormDataData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientPayerFormDataResponses,
    ClientPayerFormDataErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/payers/form_data', ...options })

/**
 * update client payer
 */
export const updateClientPayer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClientPayerData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateClientPayerResponses, UpdateClientPayerErrors, ThrowOnError>(
    {
      url: '/v1/clients/{client_id}/payers/{payer_type}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  )

/**
 * list process workflows for client
 */
export const clientProcessWorkflows = <ThrowOnError extends boolean = false>(
  options: Options<ClientProcessWorkflowsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientProcessWorkflowsResponses,
    ClientProcessWorkflowsErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/process_workflows', ...options })

/**
 * start a new workflow for the client
 */
export const createClientProcessWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<CreateClientProcessWorkflowData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateClientProcessWorkflowResponses,
    CreateClientProcessWorkflowErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/process_workflows',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get a single process workflow with Temporal detail
 */
export const clientProcessWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<ClientProcessWorkflowData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientProcessWorkflowResponses,
    ClientProcessWorkflowErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/process_workflows/{id}', ...options })

/**
 * update second guardian information for a client
 */
export const updateClientSecondGuardian = <ThrowOnError extends boolean = false>(
  options: Options<UpdateClientSecondGuardianData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateClientSecondGuardianResponses,
    UpdateClientSecondGuardianErrors,
    ThrowOnError
  >({
    url: '/v1/clients/{client_id}/second_guardian',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get active session limit for a client
 */
export const clientSessionLimit = <ThrowOnError extends boolean = false>(
  options: Options<ClientSessionLimitData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientSessionLimitResponses,
    ClientSessionLimitErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/session_limit', ...options })

/**
 * show clinical survey results for a client
 */
export const clientSurveyResults = <ThrowOnError extends boolean = false>(
  options: Options<ClientSurveyResultsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClientSurveyResultsResponses,
    ClientSurveyResultsErrors,
    ThrowOnError
  >({ url: '/v1/clients/{client_id}/survey_results', ...options })

/**
 * get client details
 */
export const clientById = <ThrowOnError extends boolean = false>(
  options: Options<ClientByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<ClientByIdResponses, ClientByIdErrors, ThrowOnError>({
    url: '/v1/clients/{id}',
    ...options,
  })

/**
 * get client profile
 */
export const clientProfile = <ThrowOnError extends boolean = false>(
  options: Options<ClientProfileData, ThrowOnError>
) =>
  (options.client ?? client).get<ClientProfileResponses, ClientProfileErrors, ThrowOnError>({
    url: '/v1/clients/{client_id}/profile',
    ...options,
  })

/**
 * returns paginated per-note Clinical Quality scores
 */
export const clinicalQualityDashboardScores = <ThrowOnError extends boolean = false>(
  options?: Options<ClinicalQualityDashboardScoresData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ClinicalQualityDashboardScoresResponses,
    ClinicalQualityDashboardScoresErrors,
    ThrowOnError
  >({ url: '/v1/clinical_quality_dashboard/scores', ...options })

/**
 * returns aggregate Clinical Quality summary for the dashboard
 */
export const clinicalQualityDashboardSummary = <ThrowOnError extends boolean = false>(
  options?: Options<ClinicalQualityDashboardSummaryData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ClinicalQualityDashboardSummaryResponses,
    ClinicalQualityDashboardSummaryErrors,
    ThrowOnError
  >({ url: '/v1/clinical_quality_dashboard/summary', ...options })

/**
 * show a clinical quality score report
 */
export const clinicalQualityScore = <ThrowOnError extends boolean = false>(
  options: Options<ClinicalQualityScoreData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClinicalQualityScoreResponses,
    ClinicalQualityScoreErrors,
    ThrowOnError
  >({ url: '/v1/clinical_quality_scores/{id}', ...options })

/**
 * search families by name
 */
export const searchClinicianMatchingClients = <ThrowOnError extends boolean = false>(
  options: Options<SearchClinicianMatchingClientsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SearchClinicianMatchingClientsResponses,
    SearchClinicianMatchingClientsErrors,
    ThrowOnError
  >({ url: '/v1/clinician_matching/clients', ...options })

/**
 * resolve a bare UUID to a journey or client
 */
export const resolveClinicianMatchingId = <ThrowOnError extends boolean = false>(
  options: Options<ResolveClinicianMatchingIdData, ThrowOnError>
) =>
  (options.client ?? client).get<ResolveClinicianMatchingIdResponses, unknown, ThrowOnError>({
    url: '/v1/clinician_matching/resolve',
    ...options,
  })

/**
 * search clinicians by name
 */
export const searchClinicianMatchingClinicians = <ThrowOnError extends boolean = false>(
  options: Options<SearchClinicianMatchingCliniciansData, ThrowOnError>
) =>
  (options.client ?? client).get<SearchClinicianMatchingCliniciansResponses, unknown, ThrowOnError>(
    { url: '/v1/clinician_matching/clinicians', ...options }
  )

/**
 * aggregate health summary over recent match runs
 */
export const clinicianMatchRunsSummary = <ThrowOnError extends boolean = false>(
  options?: Options<ClinicianMatchRunsSummaryData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ClinicianMatchRunsSummaryResponses,
    ClinicianMatchRunsSummaryErrors,
    ThrowOnError
  >({ url: '/v1/clinician_matching/runs/summary', ...options })

/**
 * intake outcomes for matched journeys over a recent window
 */
export const clinicianMatchingIntakeOutcomes = <ThrowOnError extends boolean = false>(
  options?: Options<ClinicianMatchingIntakeOutcomesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ClinicianMatchingIntakeOutcomesResponses,
    ClinicianMatchingIntakeOutcomesErrors,
    ThrowOnError
  >({ url: '/v1/clinician_matching/intake_outcomes', ...options })

/**
 * paginated history of matching-screen renders
 */
export const clinicianMatchRuns = <ThrowOnError extends boolean = false>(
  options?: Options<ClinicianMatchRunsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ClinicianMatchRunsResponses,
    ClinicianMatchRunsErrors,
    ThrowOnError
  >({ url: '/v1/clinician_matching/runs', ...options })

/**
 * paginated history of clinician selections
 */
export const clinicianSelectedMatches = <ThrowOnError extends boolean = false>(
  options?: Options<ClinicianSelectedMatchesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ClinicianSelectedMatchesResponses,
    ClinicianSelectedMatchesErrors,
    ThrowOnError
  >({ url: '/v1/clinician_matching/selected_matches', ...options })

/**
 * matching overview for a journey
 */
export const clinicianMatchingOverview = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianMatchingOverviewData, ThrowOnError>
) =>
  (options.client ?? client).get<ClinicianMatchingOverviewResponses, unknown, ThrowOnError>({
    url: '/v1/clinician_matching/journeys/{journey_id}',
    ...options,
  })

/**
 * diagnose why a clinician did or didn't match
 */
export const clinicianMatchDiagnosis = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianMatchDiagnosisData, ThrowOnError>
) =>
  (options.client ?? client).get<ClinicianMatchDiagnosisResponses, unknown, ThrowOnError>({
    url: '/v1/clinician_matching/journeys/{journey_id}/diagnose',
    ...options,
  })

/**
 * diagnose the whole in-state candidate pool
 */
export const clinicianMatchingCandidatePool = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianMatchingCandidatePoolData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClinicianMatchingCandidatePoolResponses,
    ClinicianMatchingCandidatePoolErrors,
    ThrowOnError
  >({ url: '/v1/clinician_matching/journeys/{journey_id}/candidate_pool', ...options })

/**
 * list appointments for clinician
 */
export const clinicianAppointments = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianAppointmentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClinicianAppointmentsResponses,
    ClinicianAppointmentsErrors,
    ThrowOnError
  >({ url: '/v1/clinicians/{clinician_id}/appointments', ...options })

/**
 * cancel all appointments for a clinician on a specific day
 */
export const bulkDeleteClinicianAppointments = <ThrowOnError extends boolean = false>(
  options: Options<BulkDeleteClinicianAppointmentsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkDeleteClinicianAppointmentsResponses,
    BulkDeleteClinicianAppointmentsErrors,
    ThrowOnError
  >({
    url: '/v1/clinicians/{clinician_id}/appointments/bulk_destroy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Lists the assigned clinician's appointments for a date range
 */
export const clinicianCalendarAppointments = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianCalendarAppointmentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClinicianCalendarAppointmentsResponses,
    ClinicianCalendarAppointmentsErrors,
    ThrowOnError
  >({ url: '/v1/clinicians/{clinician_id}/calendar_appointments', ...options })

/**
 * list chart notes for clinician
 */
export const clinicianChartNotes = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianChartNotesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClinicianChartNotesResponses,
    ClinicianChartNotesErrors,
    ThrowOnError
  >({ url: '/v1/clinicians/{clinician_id}/chart_notes', ...options })

/**
 * get reassignment form data
 */
export const clinicianReassignmentFormData = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianReassignmentFormDataData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ClinicianReassignmentFormDataResponses,
    ClinicianReassignmentFormDataErrors,
    ThrowOnError
  >({ url: '/v1/clinicians/{clinician_id}/reassignment_form_data', ...options })

/**
 * get clinician details
 */
export const clinicianById = <ThrowOnError extends boolean = false>(
  options: Options<ClinicianByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<ClinicianByIdResponses, ClinicianByIdErrors, ThrowOnError>({
    url: '/v1/clinicians/{id}',
    ...options,
  })

/**
 * event & comms catalog
 */
export const commsPlaygroundEvents = <ThrowOnError extends boolean = false>(
  options?: Options<CommsPlaygroundEventsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CommsPlaygroundEventsResponses,
    CommsPlaygroundEventsErrors,
    ThrowOnError
  >({ url: '/v1/comms_playground/events', ...options })

/**
 * fire a CDP event to Iterable (synthetic profile)
 */
export const commsPlaygroundTriggerEvent = <ThrowOnError extends boolean = false>(
  options?: Options<CommsPlaygroundTriggerEventData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CommsPlaygroundTriggerEventResponses,
    CommsPlaygroundTriggerEventErrors,
    ThrowOnError
  >({
    url: '/v1/comms_playground/trigger',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * unified CDP event -> comm map
 */
export const commsPlaygroundCommsMap = <ThrowOnError extends boolean = false>(
  options?: Options<CommsPlaygroundCommsMapData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CommsPlaygroundCommsMapResponses,
    CommsPlaygroundCommsMapErrors,
    ThrowOnError
  >({ url: '/v1/comms_playground/comms_map', ...options })

/**
 * merged comms timeline for a user
 */
export const commsPlaygroundUserComms = <ThrowOnError extends boolean = false>(
  options: Options<CommsPlaygroundUserCommsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    CommsPlaygroundUserCommsResponses,
    CommsPlaygroundUserCommsErrors,
    ThrowOnError
  >({ url: '/v1/comms_playground/users/{id}/comms', ...options })

/**
 * list flagged concern types
 *
 * Returns the active, flagged concern types from the catalog table that the dual-write flipper is currently writing to (ClientConcernType when :client_concerns_dual_write_JAN_2026 is OFF, ReferralConcernType when ON).
 */
export const concernTypes = <ThrowOnError extends boolean = false>(
  options?: Options<ConcernTypesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ConcernTypesResponses, unknown, ThrowOnError>({
    url: '/v1/concern_types',
    ...options,
  })

/**
 * submit feedback
 */
export const createContractUtilizationFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<CreateContractUtilizationFeedbackData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateContractUtilizationFeedbackResponses,
    CreateContractUtilizationFeedbackErrors,
    ThrowOnError
  >({
    url: '/v1/contract_utilization_feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * track badge interaction
 */
export const recordContractUtilizationBadgeInteraction = <ThrowOnError extends boolean = false>(
  options?: Options<RecordContractUtilizationBadgeInteractionData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    RecordContractUtilizationBadgeInteractionResponses,
    RecordContractUtilizationBadgeInteractionErrors,
    ThrowOnError
  >({
    url: '/v1/contract_utilization_feedback/badge_interacted',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * track badge shown
 */
export const recordContractUtilizationBadgeImpression = <ThrowOnError extends boolean = false>(
  options?: Options<RecordContractUtilizationBadgeImpressionData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    RecordContractUtilizationBadgeImpressionResponses,
    RecordContractUtilizationBadgeImpressionErrors,
    ThrowOnError
  >({ url: '/v1/contract_utilization_feedback/badge_shown', ...options })

/**
 * list conversations
 */
export const conversations = <ThrowOnError extends boolean = false>(
  options?: Options<ConversationsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ConversationsResponses, ConversationsErrors, ThrowOnError>({
    url: '/v1/conversations',
    ...options,
  })

/**
 * show conversation
 */
export const conversationById = <ThrowOnError extends boolean = false>(
  options: Options<ConversationByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<ConversationByIdResponses, ConversationByIdErrors, ThrowOnError>({
    url: '/v1/conversations/{id}',
    ...options,
  })

/**
 * Retrieve the current client's cost estimate
 */
export const costEstimate = <ThrowOnError extends boolean = false>(
  options?: Options<CostEstimateData, ThrowOnError>
) =>
  (options?.client ?? client).get<CostEstimateResponses, CostEstimateErrors, ThrowOnError>({
    url: '/v1/cost_estimate',
    ...options,
  })

/**
 * Accept the current client's cost estimate
 */
export const acceptCostEstimate = <ThrowOnError extends boolean = false>(
  options?: Options<AcceptCostEstimateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AcceptCostEstimateResponses,
    AcceptCostEstimateErrors,
    ThrowOnError
  >({ url: '/v1/cost_estimate/accept', ...options })

/**
 * Decline the current client's cost estimate
 */
export const declineCostEstimate = <ThrowOnError extends boolean = false>(
  options?: Options<DeclineCostEstimateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    DeclineCostEstimateResponses,
    DeclineCostEstimateErrors,
    ThrowOnError
  >({
    url: '/v1/cost_estimate/decline',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * get dashboard contract overview
 */
export const dashboardContractOverview = <ThrowOnError extends boolean = false>(
  options?: Options<DashboardContractOverviewData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    DashboardContractOverviewResponses,
    DashboardContractOverviewErrors,
    ThrowOnError
  >({ url: '/v1/dashboard/contract_overview', ...options })

/**
 * Submit a completed Family Interest Form
 */
export const submitFamilyInterest = <ThrowOnError extends boolean = false>(
  options?: Options<SubmitFamilyInterestData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    SubmitFamilyInterestResponses,
    SubmitFamilyInterestErrors,
    ThrowOnError
  >({
    url: '/v1/family_interests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Fetch the current family interest draft
 */
export const familyInterestDraft = <ThrowOnError extends boolean = false>(
  options?: Options<FamilyInterestDraftData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    FamilyInterestDraftResponses,
    FamilyInterestDraftErrors,
    ThrowOnError
  >({ url: '/v1/family_interests/draft', ...options })

/**
 * Update the current family interest draft
 */
export const updateFamilyInterestDraft = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateFamilyInterestDraftData, ThrowOnError>
) =>
  (options?.client ?? client).patch<
    UpdateFamilyInterestDraftResponses,
    UpdateFamilyInterestDraftErrors,
    ThrowOnError
  >({
    url: '/v1/family_interests/draft',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Fetch org context for the Family Interest Form landing
 */
export const familyInterestContext = <ThrowOnError extends boolean = false>(
  options?: Options<FamilyInterestContextData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    FamilyInterestContextResponses,
    FamilyInterestContextErrors,
    ThrowOnError
  >({ url: '/v1/family_interests/context', ...options })

/**
 * List the org's institutions + grades for the FIF student step
 */
export const familyInterestInstitutions = <ThrowOnError extends boolean = false>(
  options?: Options<FamilyInterestInstitutionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    FamilyInterestInstitutionsResponses,
    FamilyInterestInstitutionsErrors,
    ThrowOnError
  >({ url: '/v1/family_interests/institutions', ...options })

/**
 * List featured clinicians for the FIF landing preview
 *
 * Returns up to 3 admin-curated, globally featured active providers for the public FIF landing preview. Global selection (not org scoped); soft-deleted and non-provider clinicians never appear even if flagged.
 */
export const familyInterestFeaturedClinicians = <ThrowOnError extends boolean = false>(
  options?: Options<FamilyInterestFeaturedCliniciansData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    FamilyInterestFeaturedCliniciansResponses,
    FamilyInterestFeaturedCliniciansErrors,
    ThrowOnError
  >({ url: '/v1/family_interests/featured_clinicians', ...options })

/**
 * Retrieves an internal referral
 */
export const internalReferralById = <ThrowOnError extends boolean = false>(
  options: Options<InternalReferralByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    InternalReferralByIdResponses,
    InternalReferralByIdErrors,
    ThrowOnError
  >({ url: '/v1/internal_referrals/{id}', ...options })

/**
 * Declines specific services in an internal referral
 */
export const declineInternalReferral = <ThrowOnError extends boolean = false>(
  options: Options<DeclineInternalReferralData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DeclineInternalReferralResponses,
    DeclineInternalReferralErrors,
    ThrowOnError
  >({
    url: '/v1/internal_referrals/{id}/decline',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Submit availability notes for a journey
 */
export const createJourneyAvailabilityNote = <ThrowOnError extends boolean = false>(
  options: Options<CreateJourneyAvailabilityNoteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateJourneyAvailabilityNoteResponses,
    CreateJourneyAvailabilityNoteErrors,
    ThrowOnError
  >({
    url: '/v1/journeys/{journey_id}/availability_notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Defer scheduling for a journey
 */
export const createJourneySchedulingDeferral = <ThrowOnError extends boolean = false>(
  options: Options<CreateJourneySchedulingDeferralData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateJourneySchedulingDeferralResponses,
    CreateJourneySchedulingDeferralErrors,
    ThrowOnError
  >({
    url: '/v1/journeys/{journey_id}/scheduling_deferrals',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get scheduling info for a journey
 */
export const journeySchedulingInfo = <ThrowOnError extends boolean = false>(
  options: Options<JourneySchedulingInfoData, ThrowOnError>
) =>
  (options.client ?? client).get<
    JourneySchedulingInfoResponses,
    JourneySchedulingInfoErrors,
    ThrowOnError
  >({ url: '/v1/journeys/{journey_id}/scheduling_info', ...options })

/**
 * Get available appointment slots for a journey
 */
export const journeySlots = <ThrowOnError extends boolean = false>(
  options: Options<JourneySlotsData, ThrowOnError>
) =>
  (options.client ?? client).get<JourneySlotsResponses, JourneySlotsErrors, ThrowOnError>({
    url: '/v1/journeys/{journey_id}/slots',
    ...options,
  })

/**
 * Book an appointment slot for a journey
 */
export const updateJourneySlots = <ThrowOnError extends boolean = false>(
  options: Options<UpdateJourneySlotsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateJourneySlotsResponses,
    UpdateJourneySlotsErrors,
    ThrowOnError
  >({
    url: '/v1/journeys/{journey_id}/slots',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get Kustomer profile URL for an external ID
 */
export const kustomerProfile = <ThrowOnError extends boolean = false>(
  options: Options<KustomerProfileData, ThrowOnError>
) =>
  (options.client ?? client).get<KustomerProfileResponses, KustomerProfileErrors, ThrowOnError>({
    url: '/v1/kustomer_profiles/{external_id}',
    ...options,
  })

/**
 * list messages
 */
export const messages = <ThrowOnError extends boolean = false>(
  options: Options<MessagesData, ThrowOnError>
) =>
  (options.client ?? client).get<MessagesResponses, MessagesErrors, ThrowOnError>({
    url: '/v1/messages',
    ...options,
  })

/**
 * create message
 */
export const createMessage = <ThrowOnError extends boolean = false>(
  options?: Options<CreateMessageData, ThrowOnError>
) =>
  (options?.client ?? client).post<CreateMessageResponses, CreateMessageErrors, ThrowOnError>({
    url: '/v1/messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Read the family's mailing address
 *
 * Returns the family's mailing address for prefilling the FWE v2 address screen. Fields are null when no address is on file yet.
 */
export const onboardingAddress = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingAddressData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingAddressResponses, OnboardingAddressErrors, ThrowOnError>(
    { url: '/v1/onboarding/{client_signed_id}/address', ...options }
  )

/**
 * Save the family's mailing address
 */
export const saveOnboardingAddress = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingAddressData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SaveOnboardingAddressResponses,
    SaveOnboardingAddressErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/address',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Returns the family's stored weekly availability and optional reason
 *
 * FWE v2 wizard waitlist step read. `windows` is the stored set of weekly availability slots for the active referral; `reason` is the optional free-text reason rehydrated from the latest `fwe_waitlist_availability_provided` ClientEvent.
 */
export const onboardingAvailabilities = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingAvailabilitiesData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingAvailabilitiesResponses, unknown, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}/availabilities',
    ...options,
  })

/**
 * Replaces the family's stored weekly availability
 *
 * Atomically replaces all `onboarding_availability_windows` rows for the most-recent referral and records a `fwe_waitlist_availability_provided` ClientEvent. Emits AVAILABILITIES_PROVIDED on success.
 */
export const saveOnboardingAvailabilities = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingAvailabilitiesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SaveOnboardingAvailabilitiesResponses,
    SaveOnboardingAvailabilitiesErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/availabilities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Books a chosen clinician + slot for the onboarding journey
 */
export const createOnboardingJourneyBooking = <ThrowOnError extends boolean = false>(
  options: Options<CreateOnboardingJourneyBookingData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateOnboardingJourneyBookingResponses,
    CreateOnboardingJourneyBookingErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/journeys/{journey_id}/bookings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Booking summary for the terminal complete screen
 *
 * Final step of the FWE v2 wizard. Returns the family's booking summary (matched clinician, first session, and recurring schedule) for the "Your sessions are booked!" screen. All fields are null when the family has no booking yet.
 */
export const onboardingComplete = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingCompleteData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingCompleteResponses,
    OnboardingCompleteErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/complete', ...options })

/**
 * Emit the FWE v2 FWE_COMPLETED terminal event
 *
 * Emits the FWE_COMPLETED CDP event when the family reaches the complete screen (/checkout/booked). Fired once per referral (Redis idempotency guard); mutually exclusive with SESSION_HELD_END_FLOW.
 */
export const recordFweCompleted = <ThrowOnError extends boolean = false>(
  options: Options<RecordFweCompletedData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordFweCompletedResponses,
    RecordFweCompletedErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/complete-view', ...options })

/**
 * Get current concerns and the catalog of concern types
 *
 * Returns the client's existing concerns plus the full catalog of available concern types sorted by name.
 */
export const onboardingConcerns = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingConcernsData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingConcernsResponses, unknown, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}/concerns',
    ...options,
  })

/**
 * Replace the client's concerns with the submitted set
 *
 * Upserts incoming concerns by `(client_id, concern_type_id)` and deletes any persisted rows whose concern_type is missing from the payload.
 */
export const saveOnboardingConcerns = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingConcernsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SaveOnboardingConcernsResponses,
    SaveOnboardingConcernsErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/concerns',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List the consents the family must acknowledge
 *
 * Step 10 of the FWE v2 wizard. Returns the consent items applicable to this client (state- and role-filtered) and the current acceptance state for each. The React wizard renders titles and bodies from its own i18n bundle (legal_consent.signature_fields_form.*).
 */
export const onboardingConsents = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingConsentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingConsentsResponses,
    OnboardingConsentsErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/consents', ...options })

/**
 * Submit family consent acknowledgements
 *
 * Step 10 of the FWE v2 wizard. Persists the family's signature, ROI consents, third-party scribe consent, and (for staff or Brookline-eligible clients) the corresponding attestations via the existing ClientConsentForm + LegalSignatureCreator flow. Fires ConsentsSignedPublisher (the Phase 3 milestone trigger). Idempotent: a re-submit within the legal consent's one-year validity window returns the existing signature without re-firing the publisher.
 */
export const saveOnboardingConsents = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingConsentsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SaveOnboardingConsentsResponses,
    SaveOnboardingConsentsErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/consents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get wizard navigation context
 *
 * Returns the React wizard's canonical navigation context: where the family stands (current step number / total steps / current step URL) plus `steps`, the family's whole flow in order with skipped screens marked. BE owns step ordering and skip rules; the FE navigates off `steps`.
 */
export const onboardingContext = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingContextData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingContextResponses, OnboardingContextErrors, ThrowOnError>(
    { url: '/v1/onboarding/{client_signed_id}/context', ...options }
  )

/**
 * Read the cost estimate the family must confirm
 *
 * Step 8 of the FWE v2 wizard. Returns the cost estimate shape consumed by the React wizard (same hash as ClientCostEstimateDecorator#to_h) plus a top-level `status` discriminator: 'ready' when an estimate is persisted, 'unavailable' when eligibility failed (wizard routes past Step 8 to staff confirmation), 'pending' otherwise.
 */
export const onboardingCostEstimate = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingCostEstimateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingCostEstimateResponses,
    OnboardingCostEstimateErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/cost_estimate', ...options })

/**
 * Confirm the cost estimate
 *
 * Step 8 of the FWE v2 wizard. Persists cost + auto-pay consent signatures via the existing CostEstimateConfirmer flow and fires CostConfirmedPublisher. Idempotent: a re-submit returns the original confirmation timestamp without creating duplicate signatures or re-firing the publisher.
 */
export const acceptOnboardingCostEstimate = <ThrowOnError extends boolean = false>(
  options: Options<AcceptOnboardingCostEstimateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AcceptOnboardingCostEstimateResponses,
    AcceptOnboardingCostEstimateErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/cost_estimate', ...options })

/**
 * Poll the Apero eligibility outcome
 *
 * React polls every 5-10s after submitting insurance. Reads from a Redis-cached snapshot updated by Onboarding::EligibilityCheckJob — no DB hit per poll. Returns 'pending' before Apero responds, 'confirmed' on eligible result, and 'failed' on Apero error or ineligible result.
 */
export const onboardingEligibilityStatus = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingEligibilityStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingEligibilityStatusResponses,
    OnboardingEligibilityStatusErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/eligibility-status', ...options })

/**
 * List featured clinicians for the welcome screen
 *
 * Returns up to 3 admin-curated "featured" active providers for the public FWE v2 welcome screen. Global selection (not state/org scoped); soft-deleted and non-provider clinicians never appear even if flagged.
 */
export const onboardingFeaturedClinicians = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingFeaturedCliniciansData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingFeaturedCliniciansResponses,
    OnboardingFeaturedCliniciansErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/featured_clinicians', ...options })

/**
 * Acknowledge the FWE v2 financial-aid-approved re-entry screen
 *
 * Records the durable FINANCIAL_AID_APPROVAL_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial. Idempotent per referral.
 */
export const acknowledgeFinancialAidApproval = <ThrowOnError extends boolean = false>(
  options: Options<AcknowledgeFinancialAidApprovalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AcknowledgeFinancialAidApprovalResponses,
    AcknowledgeFinancialAidApprovalErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/financial-aid-approved-acknowledgment', ...options })

/**
 * Record the family's FWE v2 insurance-fallback financial aid request
 *
 * Persists the family's financial aid request: stamps the matching financial-need marker on the active referral — UNINSURED (reason: uninsured) or UNDERINSURED (reason: copay_difficult), idempotent per reason — writes an FWE_FINANCIAL_AID_REQUESTED ClientEvent carrying the reason, and emits the FINANCIAL_AID_REQUESTED CDP event for Iterable lifecycle handoff. Approval continues to flow staff-side via FinancialAidProcessor.
 */
export const requestFinancialAid = <ThrowOnError extends boolean = false>(
  options: Options<RequestFinancialAidData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RequestFinancialAidResponses,
    RequestFinancialAidErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/financial-aid-request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Return identity + language preference options for the FWE v2 wizard
 *
 * Returns all `Identity` rows grouped by category along with supported language codes, and the client's current selections on their active referral.
 */
export const onboardingIdentityPreferences = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingIdentityPreferencesData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingIdentityPreferencesResponses, unknown, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}/identity_preferences',
    ...options,
  })

/**
 * Replace identity preferences, and language preferences when supplied
 */
export const saveOnboardingIdentityPreferences = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingIdentityPreferencesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SaveOnboardingIdentityPreferencesResponses,
    SaveOnboardingIdentityPreferencesErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/identity_preferences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Emit the FWE_CARRIER_LOOKUP_VIEWED funnel event
 *
 * Emits the FWE_CARRIER_LOOKUP_VIEWED CDP event when the family reaches the "let's find your insurance" carrier picker. Fired once per referral (Redis idempotency guard), so repeat views and Back navigation don't double-count.
 */
export const recordCarrierLookupView = <ThrowOnError extends boolean = false>(
  options: Options<RecordCarrierLookupViewData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordCarrierLookupViewResponses,
    RecordCarrierLookupViewErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/insurance/carrier-lookup-view', ...options })

/**
 * Emit the FWE_COST_CONCERNS_SELECTED funnel event
 *
 * Emits the FWE_COST_CONCERNS_SELECTED CDP event when the family taps "I have concerns about the cost" on a cost-estimate screen and diverts to financial aid. The link is hidden for $0 estimates, so measure its rate against families who could see it. Fired once per referral (Redis idempotency guard).
 */
export const recordCostConcernsSelection = <ThrowOnError extends boolean = false>(
  options: Options<RecordCostConcernsSelectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordCostConcernsSelectionResponses,
    RecordCostConcernsSelectionErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/insurance/cost-concerns-selection', ...options })

/**
 * Emit the FWE_COST_ESTIMATE_VIEWED funnel event
 *
 * Emits the FWE_COST_ESTIMATE_VIEWED CDP event when the family is shown a rendered cost estimate (verified, dual-verified, or self-pay screen), carrying the family's coverage type. Fired once per referral (Redis idempotency guard).
 */
export const recordCostEstimateView = <ThrowOnError extends boolean = false>(
  options: Options<RecordCostEstimateViewData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordCostEstimateViewResponses,
    RecordCostEstimateViewErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/insurance/cost-estimate-view', ...options })

/**
 * Emit the FWE_NO_INSURANCE_SELECTED funnel event
 *
 * Emits the FWE_NO_INSURANCE_SELECTED CDP event when the family declares they have no insurance on the carrier picker (dropdown row or link). Distinct from INSURANCE_NOT_VERIFIED, which means coverage was claimed but failed verification. Fired once per referral (Redis idempotency guard).
 */
export const recordNoInsuranceSelection = <ThrowOnError extends boolean = false>(
  options: Options<RecordNoInsuranceSelectionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordNoInsuranceSelectionResponses,
    RecordNoInsuranceSelectionErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/insurance/no-insurance-selection', ...options })

/**
 * Emit the INSURANCE_NOT_VERIFIED funnel event
 *
 * Emits the INSURANCE_NOT_VERIFIED CDP event when the family reaches the 'we couldn't verify your insurance' screen after every RTE fallback failed. Fired once per referral (Redis idempotency guard).
 */
export const recordInsuranceNotVerified = <ThrowOnError extends boolean = false>(
  options: Options<RecordInsuranceNotVerifiedData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordInsuranceNotVerifiedResponses,
    RecordInsuranceNotVerifiedErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/insurance/unverified-view', ...options })

/**
 * Step 1 of the RTE cascade: cardless Nirvana discover eligibility check
 *
 * FWE v2 wizard step 5. Accepts a 5-digit ZIP code and verifiable payer ID, runs the cardless Nirvana discover flow synchronously, and writes the result to the eligibility cache. Returns 202 + poll_url regardless of the discover outcome — the React wizard polls /eligibility-status to determine next step.
 */
export const submitInsuranceZipCodeLookup = <ThrowOnError extends boolean = false>(
  options: Options<SubmitInsuranceZipCodeLookupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitInsuranceZipCodeLookupResponses,
    SubmitInsuranceZipCodeLookupErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/insurance/zip_code_lookup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Scan an insurance card via OCR
 *
 * FWE v2 wrapper around the existing InsuranceCardScanner. Attaches the supplied ActiveStorage blob(s) to the client, enqueues the Apero upload job, and returns the OCR'd insurance details for the React wizard to pre-fill the manual entry form.
 */
export const createOnboardingInsuranceScan = <ThrowOnError extends boolean = false>(
  options: Options<CreateOnboardingInsuranceScanData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateOnboardingInsuranceScanResponses,
    CreateOnboardingInsuranceScanErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/insurance_scans',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Record the family's Allentown auto-pro-bono insurance self-report
 *
 * Records what a family self-reports on the Allentown auto-pro-bono insurance self-report screen (RCM-2313): medicaid proceeds through the real, unmodified insurance verification cascade; commercial/uninsured auto-approves a pro-bono spot with family comms suppressed (RCM-2314) and fires the INSURANCE_SELECTION analytics event. Only enabled for districts with auto_pro_bono set.
 */
export const submitOnboardingInsuranceSelfReport = <ThrowOnError extends boolean = false>(
  options: Options<SubmitOnboardingInsuranceSelfReportData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitOnboardingInsuranceSelfReportResponses,
    SubmitOnboardingInsuranceSelfReportErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/insurance-self-report',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Submit insurance and trigger an Apero eligibility check
 *
 * Step 5 of the FWE v2 wizard. Persists insurance details via the existing ClientInsuranceForm pathway and enqueues an Apero eligibility check. Returns 202 with a poll_url; the React wizard polls the eligibility-status endpoint for the outcome (both confirmed and failed outcomes advance the workflow).
 */
export const submitOnboardingInsurance = <ThrowOnError extends boolean = false>(
  options: Options<SubmitOnboardingInsuranceData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitOnboardingInsuranceResponses,
    SubmitOnboardingInsuranceErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/insurance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the family's joint-custody declaration and secondary guardian info
 *
 * FWE v2 joint-consent wizard step. Returns the current declaration (`joint_custody`, `consent_authority`), the previously-captured secondary guardian (or null), and a `status` summarizing whether the workflow is required, awaiting input, in flight, or resolved. The React wizard uses `status` to decide whether to render the form, the 'session held' state, or skip the step entirely.
 */
export const onboardingJointConsents = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingJointConsentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingJointConsentsResponses,
    OnboardingJointConsentsErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/joint_consents', ...options })

/**
 * Submit the family's joint-custody declaration
 *
 * FWE v2 joint-consent wizard step. Persists the family's declaration into `referrals.custody_type` and `referrals.consent_authority`. When consent_authority is 'joint', upserts the secondary guardian as a ReferralContact, sets the JOINT_CUSTODY marker, completes any open `add_second_guardian_information` task so the running JointConsentWorkflow advances, and starts the workflow when `SecondaryGuardianConsentRequester#required?`. When consent_authority is 'sole' the primary guardian attests unilateral authority — marker and Guardian 2 upsert are skipped, so the workflow naturally does not start. Idempotent: re-POSTing the same payload updates Guardian 2 in place and avoids duplicate marker / ReferralContact / workflow start rows.
 */
export const saveOnboardingJointConsents = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingJointConsentsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SaveOnboardingJointConsentsResponses,
    SaveOnboardingJointConsentsErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/joint_consents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Materializes the matching journey for the family's selected service lines
 *
 * Creates a Journey per tentatively-selected service line (idempotent) and returns the journey id the matching step should render matches for. Backs the FWE v2 'Finding the right fit' loading interstitial (RCM-1914).
 */
export const createOnboardingMatchingJourney = <ThrowOnError extends boolean = false>(
  options: Options<CreateOnboardingMatchingJourneyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateOnboardingMatchingJourneyResponses,
    CreateOnboardingMatchingJourneyErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/journeys', ...options })

/**
 * Match summary for the "We found a match" re-entry screen
 *
 * Waitlist re-entry. Returns the matched clinician's profile and the held first session + recurring schedule for the "We found a match" screen after a coordinator booked a waitlisted family. Booking values are derived from the journey's appointments (these families have no RequestedAppointmentSchedule). All fields are null when no booking exists yet.
 */
export const onboardingMatch = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingMatchData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingMatchResponses, OnboardingMatchErrors, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}/match',
    ...options,
  })

/**
 * Return the family's meeting-location preference for the active referral
 *
 * Returns the family's current meeting-location preference (`during_school` / `outside_school` / `both`), or null if not yet chosen.
 */
export const onboardingMeetingPreference = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingMeetingPreferenceData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingMeetingPreferenceResponses, unknown, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}/meeting-preference',
    ...options,
  })

/**
 * Persist the meeting-location preference for the active referral
 */
export const saveOnboardingMeetingPreference = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingMeetingPreferenceData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SaveOnboardingMeetingPreferenceResponses,
    SaveOnboardingMeetingPreferenceErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/meeting-preference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List payers available in the client's state with eligibility metadata
 *
 * Returns the state-filtered carrier dropdown for the FWE v2 insurance step. State is inferred from the resolved client. Each payer carries its Apero mapping (or null) and a normalized network_status enum so the React form can render in-network indicators and kick off eligibility checks without an extra round trip.
 */
export const onboardingPayers = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingPayersData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingPayersResponses, OnboardingPayersErrors, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}/payers',
    ...options,
  })

/**
 * Start a Stripe Checkout setup session for the family's payment method
 *
 * Provisions a Stripe Checkout Session in setup mode and returns the client_secret + session id for the React wizard to render Stripe Elements (embedded mode). Idempotent within a 5-minute window: repeated calls for the same client return the same checkout_session_id.
 */
export const createOnboardingPaymentMethodSetupIntent = <ThrowOnError extends boolean = false>(
  options: Options<CreateOnboardingPaymentMethodSetupIntentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateOnboardingPaymentMethodSetupIntentResponses,
    CreateOnboardingPaymentMethodSetupIntentErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/payment_method/setup_intent', ...options })

/**
 * Acknowledge the FWE v2 red-flag-approved re-entry screen
 *
 * Records the durable FIF_RED_FLAG_APPROVAL_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial. Idempotent per referral.
 */
export const acknowledgeRedFlagApproval = <ThrowOnError extends boolean = false>(
  options: Options<AcknowledgeRedFlagApprovalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AcknowledgeRedFlagApprovalResponses,
    AcknowledgeRedFlagApprovalErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/red-flag-approved-acknowledgment', ...options })

/**
 * Record the family's FWE v2 self-pay (out-of-pocket) choice
 *
 * Records the family's choice to pay out-of-pocket from the insurance-carrier step: creates the self_pay cost estimate ($145 intake / $120 ongoing) and flags the referral with the SELF_PAID marker, which lets clinician matching bypass the in-network payer hard filter (RCM-1935). Idempotent: re-selecting self-pay returns the existing estimate without creating a duplicate. Returns the estimate so the wizard renders the Pay Out-of-pocket screen.
 */
export const submitOnboardingSelfPay = <ThrowOnError extends boolean = false>(
  options: Options<SubmitOnboardingSelfPayData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitOnboardingSelfPayResponses,
    SubmitOnboardingSelfPayErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/self-pay', ...options })

/**
 * Returns selectable service lines and the current tentative selection
 *
 * FWE v2 wizard Step 3 read. `available` is the catalog of externally-referable services; `selected` is the current set of tentative service-line UUIDs stored on `client_selected_preferences`.
 */
export const onboardingServiceLines = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingServiceLinesData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingServiceLinesResponses, unknown, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}/service_lines',
    ...options,
  })

/**
 * Replaces the family's tentative service-line selection
 *
 * Atomically replaces all `client_selected_preferences` rows with `preference_type: service_line` for the most-recent referral. Emits SERVICE_LINES_SELECTED on success.
 */
export const saveOnboardingServiceLines = <ThrowOnError extends boolean = false>(
  options: Options<SaveOnboardingServiceLinesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SaveOnboardingServiceLinesResponses,
    SaveOnboardingServiceLinesErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/service_lines',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Booking summary + hold reason for the session-held terminal screen
 *
 * Terminal step of the FWE v2 held path. Returns the family's booking summary (matched clinician, first session, recurring schedule) plus `pending_reason` — the outstanding staff-verification blocker (school_approval / insurance / guardian_2 / financial_aid). `pending_reason` is null once the hold clears (→ complete screen).
 */
export const onboardingSessionHeld = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingSessionHeldData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingSessionHeldResponses,
    OnboardingSessionHeldErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/session-held', ...options })

/**
 * Emit the FWE v2 SESSION_HELD_END_FLOW terminal event
 *
 * Emits the SESSION_HELD_END_FLOW CDP event when the family reaches the session-held screen. reason_for_hold is derived backend from PrerequisitesChecker. Fired once per referral (Redis idempotency guard).
 */
export const recordSessionHeldEndFlow = <ThrowOnError extends boolean = false>(
  options: Options<RecordSessionHeldEndFlowData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordSessionHeldEndFlowResponses,
    RecordSessionHeldEndFlowErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/session-held-view', ...options })

/**
 * Emit the FWE v2 TIMESLOT_SELECTED funnel event
 *
 * Emits the TIMESLOT_SELECTED CDP event when the family selects a timeslot (pre-confirm). Emit-only; clinician_name is resolved backend and `filters` passes through the family's selected matching filters when supplied.
 */
export const recordTimeslotSelected = <ThrowOnError extends boolean = false>(
  options: Options<RecordTimeslotSelectedData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordTimeslotSelectedResponses,
    RecordTimeslotSelectedErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/timeslot-selection',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Report whether the session is verified for this student's FWE form
 *
 * Returns the client when the current session was verified for the client this signed_id resolves to. The FWE gate is per-student: a session verified for one child (e.g. a sibling) is NOT considered verified for another child's form, so this returns 401 whenever the session client differs from the signed-id's client (or no session exists).
 */
export const onboardingVerificationStatus = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingVerificationStatusData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OnboardingVerificationStatusResponses,
    OnboardingVerificationStatusErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/verification', ...options })

/**
 * Verify a family's identity to start the FWE v2 wizard
 *
 * Validates the submitted first name, last name, and date of birth against the client record, persists the phone number, and transitions the referral into outreach_waiting_for_family. Idempotent: a second successful call no-ops the AASM transition and the FWE_STARTED ClientEvent.
 */
export const verifyFamilyIdentity = <ThrowOnError extends boolean = false>(
  options: Options<VerifyFamilyIdentityData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VerifyFamilyIdentityResponses,
    VerifyFamilyIdentityErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Emit the FWE v2 WAITLIST_END_FLOW terminal event
 *
 * Emits the WAITLIST_END_FLOW CDP event when the family reaches the waitlist-confirmed screen. Fired once per referral (Redis idempotency guard).
 */
export const recordWaitlistEndFlow = <ThrowOnError extends boolean = false>(
  options: Options<RecordWaitlistEndFlowData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordWaitlistEndFlowResponses,
    RecordWaitlistEndFlowErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/waitlist-confirmed-view', ...options })

/**
 * Record that the family entered the FWE v2 waitlist flow
 *
 * Emits the WAITLIST_REQUESTED CDP event and records a durable client event when the family enters the waitlist flow. `forced` records whether the family chose the waitlist or was routed there with no clinicians available. `source` records why the family entered the waitlist — 'clinician_match' (from the matching screen) or 'rte_failure' (Plan B: insurance couldn't be verified).
 */
export const recordWaitlistRequested = <ThrowOnError extends boolean = false>(
  options: Options<RecordWaitlistRequestedData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RecordWaitlistRequestedResponses,
    RecordWaitlistRequestedErrors,
    ThrowOnError
  >({
    url: '/v1/onboarding/{client_signed_id}/waitlist-request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Acknowledge the FWE v2 we-found-a-match re-entry screen
 *
 * Records the durable FWE_WAITLIST_MATCH_ACKNOWLEDGED event so OnboardingManager advances the family off the interstitial into Phase 3. Idempotent per referral.
 */
export const acknowledgeWaitlistMatch = <ThrowOnError extends boolean = false>(
  options: Options<AcknowledgeWaitlistMatchData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AcknowledgeWaitlistMatchResponses,
    AcknowledgeWaitlistMatchErrors,
    ThrowOnError
  >({ url: '/v1/onboarding/{client_signed_id}/we-found-a-match-acknowledgment', ...options })

/**
 * Resolve onboarding client from signed id
 *
 * Foundation endpoint for the FWE v2 wizard. Returns the resolved client for any valid onboarding signed id. Acts as the smoke-test for the Api::V1::Onboarding::BaseController authentication path.
 */
export const onboardingById = <ThrowOnError extends boolean = false>(
  options: Options<OnboardingByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<OnboardingByIdResponses, OnboardingByIdErrors, ThrowOnError>({
    url: '/v1/onboarding/{client_signed_id}',
    ...options,
  })

/**
 * list institutions for an organization
 *
 * Returns the active institutions belonging to the organization, each with its institution_grades. Used by the new referral wizard's student step to populate the school and grade dropdowns.
 */
export const organizationInstitutions = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationInstitutionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    OrganizationInstitutionsResponses,
    OrganizationInstitutionsErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{organization_id}/institutions', ...options })

/**
 * assign or clear a school's referral contact
 *
 * Sets (or clears, with a null id) the school's referral contact — the person used to back-fill the referrer on that school's auto-approved FIFs. Admin / program manager only.
 */
export const updateSchoolReferralContact = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSchoolReferralContactData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateSchoolReferralContactResponses,
    UpdateSchoolReferralContactErrors,
    ThrowOnError
  >({
    url: '/v1/organizations/{organization_id}/institutions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * reset all schools to the district MPOC default
 *
 * Clears every school's configured referral contact for the organization so they fall back to the district MPOC default. Admin / program manager only.
 */
export const resetOrganizationReferralContacts = <ThrowOnError extends boolean = false>(
  options: Options<ResetOrganizationReferralContactsData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ResetOrganizationReferralContactsResponses,
    ResetOrganizationReferralContactsErrors,
    ThrowOnError
  >({ url: '/v1/organizations/{organization_id}/referral_contacts', ...options })

/**
 * list an organization's staff for the referral-contact picker
 *
 * Active staff eligible to be a school referral contact, plus the district MPOC default(s) a school falls back to when none is configured. Admin / program manager only.
 */
export const organizationStaff = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationStaffData, ThrowOnError>
) =>
  (options.client ?? client).get<OrganizationStaffResponses, OrganizationStaffErrors, ThrowOnError>(
    { url: '/v1/organizations/{organization_id}/staff', ...options }
  )

/**
 * list payers
 */
export const payers = <ThrowOnError extends boolean = false>(
  options?: Options<PayersData, ThrowOnError>
) =>
  (options?.client ?? client).get<PayersResponses, unknown, ThrowOnError>({
    url: '/v1/payers',
    ...options,
  })

/**
 * Dismisses the current product update announcement
 */
export const dismissProductAnnouncement = <ThrowOnError extends boolean = false>(
  options?: Options<DismissProductAnnouncementData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    DismissProductAnnouncementResponses,
    DismissProductAnnouncementErrors,
    ThrowOnError
  >({ url: '/v1/product_announcements/dismissal', ...options })

/**
 * list reassignments
 */
export const reassignments = <ThrowOnError extends boolean = false>(
  options?: Options<ReassignmentsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ReassignmentsResponses, ReassignmentsErrors, ThrowOnError>({
    url: '/v1/reassignments',
    ...options,
  })

/**
 * create reassignment
 */
export const createReassignment = <ThrowOnError extends boolean = false>(
  options?: Options<CreateReassignmentData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateReassignmentResponses,
    CreateReassignmentErrors,
    ThrowOnError
  >({
    url: '/v1/reassignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * get reassignment details
 */
export const reassignmentById = <ThrowOnError extends boolean = false>(
  options: Options<ReassignmentByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<ReassignmentByIdResponses, ReassignmentByIdErrors, ThrowOnError>({
    url: '/v1/reassignments/{id}',
    ...options,
  })

/**
 * update reassignment
 */
export const updateReassignment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateReassignmentData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateReassignmentResponses,
    UpdateReassignmentErrors,
    ThrowOnError
  >({
    url: '/v1/reassignments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Manually advance a referral's onboarding milestone
 */
export const advanceOnboardingMilestone = <ThrowOnError extends boolean = false>(
  options: Options<AdvanceOnboardingMilestoneData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AdvanceOnboardingMilestoneResponses,
    AdvanceOnboardingMilestoneErrors,
    ThrowOnError
  >({
    url: '/v1/referrals/{referral_id}/milestones',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch a referral's onboarding progress
 */
export const referralOnboardingProgress = <ThrowOnError extends boolean = false>(
  options: Options<ReferralOnboardingProgressData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ReferralOnboardingProgressResponses,
    ReferralOnboardingProgressErrors,
    ThrowOnError
  >({ url: '/v1/referrals/{referral_id}/onboarding_progress', ...options })

/**
 * Clear the current referral draft
 */
export const clearReferralDraft = <ThrowOnError extends boolean = false>(
  options?: Options<ClearReferralDraftData, ThrowOnError>
) =>
  (options?.client ?? client).delete<
    ClearReferralDraftResponses,
    ClearReferralDraftErrors,
    ThrowOnError
  >({ url: '/v1/referrals/draft', ...options })

/**
 * Fetch the current referral draft
 */
export const referralDraft = <ThrowOnError extends boolean = false>(
  options?: Options<ReferralDraftData, ThrowOnError>
) =>
  (options?.client ?? client).get<ReferralDraftResponses, ReferralDraftErrors, ThrowOnError>({
    url: '/v1/referrals/draft',
    ...options,
  })

/**
 * Update the current referral draft
 */
export const updateReferralDraft = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateReferralDraftData, ThrowOnError>
) =>
  (options?.client ?? client).patch<
    UpdateReferralDraftResponses,
    UpdateReferralDraftErrors,
    ThrowOnError
  >({
    url: '/v1/referrals/draft',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Submit the completed referral
 */
export const createReferral = <ThrowOnError extends boolean = false>(
  options?: Options<CreateReferralData, ThrowOnError>
) =>
  (options?.client ?? client).post<CreateReferralResponses, CreateReferralErrors, ThrowOnError>({
    url: '/v1/referrals',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Books a selected clinician for a reassignment
 */
export const createSchedulingBooking = <ThrowOnError extends boolean = false>(
  options: Options<CreateSchedulingBookingData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateSchedulingBookingResponses,
    CreateSchedulingBookingErrors,
    ThrowOnError
  >({
    url: '/v1/scheduling/journeys/{journey_id}/bookings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Lists clinician matches for a scheduling journey
 */
export const schedulingClinicianMatches = <ThrowOnError extends boolean = false>(
  options: Options<SchedulingClinicianMatchesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SchedulingClinicianMatchesResponses,
    SchedulingClinicianMatchesErrors,
    ThrowOnError
  >({ url: '/v1/scheduling/journeys/{journey_id}/clinician_matches', ...options })

/**
 * Fetches a clinician profile for a scheduling journey
 */
export const schedulingClinicianMatch = <ThrowOnError extends boolean = false>(
  options: Options<SchedulingClinicianMatchData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SchedulingClinicianMatchResponses,
    SchedulingClinicianMatchErrors,
    ThrowOnError
  >({ url: '/v1/scheduling/journeys/{journey_id}/clinician_matches/{id}', ...options })

/**
 * Resolves the family scheduling experience
 */
export const schedulingContext = <ThrowOnError extends boolean = false>(
  options: Options<SchedulingContextData, ThrowOnError>
) =>
  (options.client ?? client).get<SchedulingContextResponses, SchedulingContextErrors, ThrowOnError>(
    { url: '/v1/scheduling/journeys/{journey_id}/context', ...options }
  )

/**
 * Saves referral-scoped scheduling identity preferences
 */
export const saveSchedulingIdentityPreferences = <ThrowOnError extends boolean = false>(
  options: Options<SaveSchedulingIdentityPreferencesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SaveSchedulingIdentityPreferencesResponses,
    SaveSchedulingIdentityPreferencesErrors,
    ThrowOnError
  >({
    url: '/v1/scheduling/journeys/{journey_id}/preferences/identity',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Saves the referral-scoped scheduling meeting preference
 */
export const saveSchedulingMeetingPreference = <ThrowOnError extends boolean = false>(
  options: Options<SaveSchedulingMeetingPreferenceData, ThrowOnError>
) =>
  (options.client ?? client).put<
    SaveSchedulingMeetingPreferenceResponses,
    SaveSchedulingMeetingPreferenceErrors,
    ThrowOnError
  >({
    url: '/v1/scheduling/journeys/{journey_id}/preferences/meeting-preference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Requests coordinator help for reassignment scheduling
 */
export const requestReassignmentSchedulingHelp = <ThrowOnError extends boolean = false>(
  options: Options<RequestReassignmentSchedulingHelpData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RequestReassignmentSchedulingHelpResponses,
    RequestReassignmentSchedulingHelpErrors,
    ThrowOnError
  >({
    url: '/v1/scheduling/journeys/{journey_id}/request-help',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Check reauthorization eligibility for a session limit
 */
export const reauthorizationEligibility = <ThrowOnError extends boolean = false>(
  options: Options<ReauthorizationEligibilityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ReauthorizationEligibilityResponses,
    ReauthorizationEligibilityErrors,
    ThrowOnError
  >({ url: '/v1/session_limits/{session_limit_id}/reauthorization/eligibility', ...options })

/**
 * Fetch reauthorization review summary for MPOC
 */
export const reauthorizationReviewSummary = <ThrowOnError extends boolean = false>(
  options: Options<ReauthorizationReviewSummaryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ReauthorizationReviewSummaryResponses,
    ReauthorizationReviewSummaryErrors,
    ThrowOnError
  >({ url: '/v1/session_limits/{session_limit_id}/reauthorization/review_summary', ...options })

/**
 * Submit MPOC approval or denial decision
 */
export const decideReauthorization = <ThrowOnError extends boolean = false>(
  options: Options<DecideReauthorizationData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DecideReauthorizationResponses,
    DecideReauthorizationErrors,
    ThrowOnError
  >({
    url: '/v1/session_limits/{session_limit_id}/reauthorization/mpoc_decision',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get schedule configuration
 */
export const clientInfoUpdateSchedule = <ThrowOnError extends boolean = false>(
  options?: Options<ClientInfoUpdateScheduleData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ClientInfoUpdateScheduleResponses,
    ClientInfoUpdateScheduleErrors,
    ThrowOnError
  >({ url: '/v1/client_info_updates/schedule', ...options })

/**
 * Update schedule configuration
 */
export const updateClientInfoUpdateSchedule = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateClientInfoUpdateScheduleData, ThrowOnError>
) =>
  (options?.client ?? client).patch<
    UpdateClientInfoUpdateScheduleResponses,
    UpdateClientInfoUpdateScheduleErrors,
    ThrowOnError
  >({
    url: '/v1/client_info_updates/schedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Manually trigger update requests
 */
export const triggerClientInfoUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<TriggerClientInfoUpdateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    TriggerClientInfoUpdateResponses,
    TriggerClientInfoUpdateErrors,
    ThrowOnError
  >({ url: '/v1/client_info_updates/trigger', ...options })

/**
 * list all survey responses
 */
export const surveyResponses = <ThrowOnError extends boolean = false>(
  options?: Options<SurveyResponsesData, ThrowOnError>
) =>
  (options?.client ?? client).get<SurveyResponsesResponses, unknown, ThrowOnError>({
    url: '/v1/survey_responses',
    ...options,
  })

/**
 * get survey response by ID
 */
export const surveyResponseById = <ThrowOnError extends boolean = false>(
  options: Options<SurveyResponseByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SurveyResponseByIdResponses,
    SurveyResponseByIdErrors,
    ThrowOnError
  >({ url: '/v1/survey_responses/{id}', ...options })

/**
 * list all survey schemas
 */
export const surveySchemas = <ThrowOnError extends boolean = false>(
  options?: Options<SurveySchemasData, ThrowOnError>
) =>
  (options?.client ?? client).get<SurveySchemasResponses, unknown, ThrowOnError>({
    url: '/v1/survey_schemas',
    ...options,
  })

/**
 * get survey schema by ID
 */
export const surveySchemaById = <ThrowOnError extends boolean = false>(
  options: Options<SurveySchemaByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<SurveySchemaByIdResponses, SurveySchemaByIdErrors, ThrowOnError>({
    url: '/v1/survey_schemas/{id}',
    ...options,
  })

/**
 * delete a survey
 */
export const deleteSurvey = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSurveyData, ThrowOnError>
) =>
  (options.client ?? client).delete<DeleteSurveyResponses, DeleteSurveyErrors, ThrowOnError>({
    url: '/v1/surveys/{id}',
    ...options,
  })

/**
 * get SurveyJS form by ID
 */
export const surveyById = <ThrowOnError extends boolean = false>(
  options: Options<SurveyByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<SurveyByIdResponses, SurveyByIdErrors, ThrowOnError>({
    url: '/v1/surveys/{id}',
    ...options,
  })

/**
 * update a survey
 */
export const updateSurvey = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSurveyData, ThrowOnError>
) =>
  (options.client ?? client).put<UpdateSurveyResponses, UpdateSurveyErrors, ThrowOnError>({
    url: '/v1/surveys/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list all surveys
 */
export const surveys = <ThrowOnError extends boolean = false>(
  options?: Options<SurveysData, ThrowOnError>
) =>
  (options?.client ?? client).get<SurveysResponses, unknown, ThrowOnError>({
    url: '/v1/surveys',
    ...options,
  })

/**
 * create a new survey
 */
export const createSurvey = <ThrowOnError extends boolean = false>(
  options?: Options<CreateSurveyData, ThrowOnError>
) =>
  (options?.client ?? client).post<CreateSurveyResponses, CreateSurveyErrors, ThrowOnError>({
    url: '/v1/surveys',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * get survey by name for responding
 */
export const respondToSurvey = <ThrowOnError extends boolean = false>(
  options?: Options<RespondToSurveyData, ThrowOnError>
) =>
  (options?.client ?? client).get<RespondToSurveyResponses, RespondToSurveyErrors, ThrowOnError>({
    url: '/v1/surveys/respond',
    ...options,
  })

/**
 * submit survey response
 */
export const submitSurveyResponseCallback = <ThrowOnError extends boolean = false>(
  options: Options<SubmitSurveyResponseCallbackData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitSurveyResponseCallbackResponses,
    SubmitSurveyResponseCallbackErrors,
    ThrowOnError
  >({
    url: '/v1/surveys/{id}/respond_callback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get insurance verification context for a task
 */
export const taskInsuranceVerificationContext = <ThrowOnError extends boolean = false>(
  options: Options<TaskInsuranceVerificationContextData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TaskInsuranceVerificationContextResponses,
    TaskInsuranceVerificationContextErrors,
    ThrowOnError
  >({ url: '/v1/tasks/{task_id}/insurance_verification_context', ...options })

/**
 * resolve a verify-insurance task
 */
export const taskResolveVerifyInsurance = <ThrowOnError extends boolean = false>(
  options: Options<TaskResolveVerifyInsuranceData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TaskResolveVerifyInsuranceResponses,
    TaskResolveVerifyInsuranceErrors,
    ThrowOnError
  >({
    url: '/v1/tasks/{task_id}/insurance_verification_context/resolve_verify_insurance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * resolve a Medicaid MCO Mapping task
 */
export const taskResolveMedicaidMcoMapping = <ThrowOnError extends boolean = false>(
  options: Options<TaskResolveMedicaidMcoMappingData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TaskResolveMedicaidMcoMappingResponses,
    TaskResolveMedicaidMcoMappingErrors,
    ThrowOnError
  >({
    url: '/v1/tasks/{task_id}/insurance_verification_context/resolve_medicaid_mco_mapping',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list tasks
 */
export const tasks = <ThrowOnError extends boolean = false>(
  options?: Options<TasksData, ThrowOnError>
) =>
  (options?.client ?? client).get<TasksResponses, unknown, ThrowOnError>({
    url: '/v1/tasks',
    ...options,
  })

/**
 * get my tasks
 */
export const myTasks = <ThrowOnError extends boolean = false>(
  options?: Options<MyTasksData, ThrowOnError>
) =>
  (options?.client ?? client).get<MyTasksResponses, MyTasksErrors, ThrowOnError>({
    url: '/v1/tasks/mine',
    ...options,
  })

/**
 * get task
 */
export const taskById = <ThrowOnError extends boolean = false>(
  options: Options<TaskByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<TaskByIdResponses, unknown, ThrowOnError>({
    url: '/v1/tasks/{id}',
    ...options,
  })

/**
 * start a task
 */
export const claimTask = <ThrowOnError extends boolean = false>(
  options: Options<ClaimTaskData, ThrowOnError>
) =>
  (options.client ?? client).post<ClaimTaskResponses, ClaimTaskErrors, ThrowOnError>({
    url: '/v1/tasks/{id}/claim',
    ...options,
  })

/**
 * release a task
 */
export const releaseTask = <ThrowOnError extends boolean = false>(
  options: Options<ReleaseTaskData, ThrowOnError>
) =>
  (options.client ?? client).delete<ReleaseTaskResponses, ReleaseTaskErrors, ThrowOnError>({
    url: '/v1/tasks/{id}/release',
    ...options,
  })

/**
 * assign a task
 */
export const assignTask = <ThrowOnError extends boolean = false>(
  options: Options<AssignTaskData, ThrowOnError>
) =>
  (options.client ?? client).patch<AssignTaskResponses, AssignTaskErrors, ThrowOnError>({
    url: '/v1/tasks/{id}/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * record a joint consent escalation outcome
 */
export const recordJointConsentTaskEscalationOutcome = <ThrowOnError extends boolean = false>(
  options: Options<RecordJointConsentTaskEscalationOutcomeData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    RecordJointConsentTaskEscalationOutcomeResponses,
    RecordJointConsentTaskEscalationOutcomeErrors,
    ThrowOnError
  >({
    url: '/v1/joint_consent/tasks/{task_id}/escalation_outcome',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get schedule intake context for a task
 */
export const taskScheduleIntakeContext = <ThrowOnError extends boolean = false>(
  options: Options<TaskScheduleIntakeContextData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TaskScheduleIntakeContextResponses,
    TaskScheduleIntakeContextErrors,
    ThrowOnError
  >({ url: '/v1/tasks/{task_id}/schedule_intake_context', ...options })

/**
 * get reassignment scheduling context for a task
 */
export const taskReassignmentSchedulingContext = <ThrowOnError extends boolean = false>(
  options: Options<TaskReassignmentSchedulingContextData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TaskReassignmentSchedulingContextResponses,
    TaskReassignmentSchedulingContextErrors,
    ThrowOnError
  >({ url: '/v1/tasks/{task_id}/reassignment_scheduling_context', ...options })

/**
 * get scheduling context for a task
 */
export const taskSchedulingContext = <ThrowOnError extends boolean = false>(
  options: Options<TaskSchedulingContextData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TaskSchedulingContextResponses,
    TaskSchedulingContextErrors,
    ThrowOnError
  >({ url: '/v1/tasks/{task_id}/scheduling_context', ...options })

/**
 * complete a task
 */
export const completeTask = <ThrowOnError extends boolean = false>(
  options: Options<CompleteTaskData, ThrowOnError>
) =>
  (options.client ?? client).patch<CompleteTaskResponses, CompleteTaskErrors, ThrowOnError>({
    url: '/v1/tasks/{id}/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * get reauthorization review context for a task
 */
export const reauthorizationReviewContext = <ThrowOnError extends boolean = false>(
  options: Options<ReauthorizationReviewContextData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ReauthorizationReviewContextResponses,
    ReauthorizationReviewContextErrors,
    ThrowOnError
  >({ url: '/v1/tasks/{task_id}/reauthorization_review', ...options })

/**
 * record a clinical supervisor's approve/deny decision on a reauthorization
 */
export const decideClinicalReauthorization = <ThrowOnError extends boolean = false>(
  options: Options<DecideClinicalReauthorizationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DecideClinicalReauthorizationResponses,
    DecideClinicalReauthorizationErrors,
    ThrowOnError
  >({
    url: '/v1/tasks/{task_id}/clinical_decision',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list task events (history)
 */
export const taskEvents = <ThrowOnError extends boolean = false>(
  options: Options<TaskEventsData, ThrowOnError>
) =>
  (options.client ?? client).get<TaskEventsResponses, TaskEventsErrors, ThrowOnError>({
    url: '/v1/tasks/{task_id}/events',
    ...options,
  })

/**
 * add a note to a task
 */
export const createTaskNote = <ThrowOnError extends boolean = false>(
  options: Options<CreateTaskNoteData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateTaskNoteResponses, CreateTaskNoteErrors, ThrowOnError>({
    url: '/v1/tasks/{task_id}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * mark the first-login onboarding tour as finished
 */
export const createReferrerTourCompletion = <ThrowOnError extends boolean = false>(
  options?: Options<CreateReferrerTourCompletionData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateReferrerTourCompletionResponses,
    CreateReferrerTourCompletionErrors,
    ThrowOnError
  >({
    url: '/v1/users/referrer_tour_completion',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * list internal users
 */
export const users = <ThrowOnError extends boolean = false>(
  options?: Options<UsersData, ThrowOnError>
) =>
  (options?.client ?? client).get<UsersResponses, UsersErrors, ThrowOnError>({
    url: '/v1/users',
    ...options,
  })

/**
 * get current user information
 */
export const currentUser = <ThrowOnError extends boolean = false>(
  options?: Options<CurrentUserData, ThrowOnError>
) =>
  (options?.client ?? client).get<CurrentUserResponses, CurrentUserErrors, ThrowOnError>({
    url: '/v1/users/current_user',
    ...options,
  })

/**
 * get current user profile fields
 *
 * Returns first_name, last_name, email, phone_number, and title for the signed-in user. Used to pre-fill contact cards (e.g. the referral wizard's school emergency contact step).
 */
export const currentUserProfile = <ThrowOnError extends boolean = false>(
  options?: Options<CurrentUserProfileData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CurrentUserProfileResponses,
    CurrentUserProfileErrors,
    ThrowOnError
  >({ url: '/v1/users/current_user_profile', ...options })

/**
 * get current verified client information
 *
 * Returns the current verified client from the session. Used by client-facing pages to check verification status.
 */
export const getCurrentClient = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentClientData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetCurrentClientResponses, GetCurrentClientErrors, ThrowOnError>({
    url: '/v1/users/current_client',
    ...options,
  })

/**
 * Verify client identity
 *
 * Verify client identity using personal details. Sets client session on success.
 */
export const verifyClient = <ThrowOnError extends boolean = false>(
  options?: Options<VerifyClientData, ThrowOnError>
) =>
  (options?.client ?? client).post<VerifyClientResponses, VerifyClientErrors, ThrowOnError>({
    url: '/v1/users/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * update a user's phone number
 *
 * Updates a single user's phone number — used by the 'Save to profile' prompt when assigning a school referral contact who has no phone on file. Admins and program managers for any user, district admins for users within their own district, or a user updating their own phone number.
 */
export const updateUserPhoneNumber = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserPhoneNumberData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateUserPhoneNumberResponses,
    UpdateUserPhoneNumberErrors,
    ThrowOnError
  >({
    url: '/v1/users/{id}/phone_number',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list claims pending review
 */
export const wheelhouseClaims = <ThrowOnError extends boolean = false>(
  options?: Options<WheelhouseClaimsData, ThrowOnError>
) =>
  (options?.client ?? client).get<WheelhouseClaimsResponses, unknown, ThrowOnError>({
    url: '/v1/wheelhouse/claims',
    ...options,
  })

/**
 * fetch a claim
 */
export const wheelhouseClaim = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseClaimData, ThrowOnError>
) =>
  (options.client ?? client).get<WheelhouseClaimResponses, WheelhouseClaimErrors, ThrowOnError>({
    url: '/v1/wheelhouse/claims/{id}',
    ...options,
  })

/**
 * edit a claim's service fields
 */
export const updateWheelhouseClaim = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWheelhouseClaimData, ThrowOnError>
) =>
  (options.client ?? client).patch<UpdateWheelhouseClaimResponses, unknown, ThrowOnError>({
    url: '/v1/wheelhouse/claims/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * sign and submit a claim
 */
export const signWheelhouseClaim = <ThrowOnError extends boolean = false>(
  options: Options<SignWheelhouseClaimData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SignWheelhouseClaimResponses,
    SignWheelhouseClaimErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/claims/{claim_id}/signature',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * skip (reject) a claim
 */
export const rejectWheelhouseClaim = <ThrowOnError extends boolean = false>(
  options: Options<RejectWheelhouseClaimData, ThrowOnError>
) =>
  (options.client ?? client).post<RejectWheelhouseClaimResponses, unknown, ThrowOnError>({
    url: '/v1/wheelhouse/claims/{claim_id}/rejection',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list the provider's students
 */
export const wheelhouseClients = <ThrowOnError extends boolean = false>(
  options?: Options<WheelhouseClientsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    WheelhouseClientsResponses,
    WheelhouseClientsErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/clients', ...options })

/**
 * show a single student's detail record
 */
export const wheelhouseClient = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseClientData, ThrowOnError>
) =>
  (options.client ?? client).get<WheelhouseClientResponses, WheelhouseClientErrors, ThrowOnError>({
    url: '/v1/wheelhouse/clients/{id}',
    ...options,
  })

/**
 * list a student's documents
 */
export const wheelhouseClientDocuments = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseClientDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WheelhouseClientDocumentsResponses,
    WheelhouseClientDocumentsErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/clients/{client_id}/documents', ...options })

/**
 * request a document
 */
export const createWheelhouseDocument = <ThrowOnError extends boolean = false>(
  options: Options<CreateWheelhouseDocumentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateWheelhouseDocumentResponses,
    CreateWheelhouseDocumentErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/clients/{client_id}/documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * fetch a document
 */
export const wheelhouseDocument = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseDocumentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WheelhouseDocumentResponses,
    WheelhouseDocumentErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/documents/{id}', ...options })

/**
 * edit a generated document
 */
export const updateWheelhouseDocument = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWheelhouseDocumentData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateWheelhouseDocumentResponses,
    UpdateWheelhouseDocumentErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/documents/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list the provider's encounters
 */
export const wheelhouseEncounters = <ThrowOnError extends boolean = false>(
  options?: Options<WheelhouseEncountersData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    WheelhouseEncountersResponses,
    WheelhouseEncountersErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/encounters', ...options })

/**
 * start a session (encounter + draft note)
 */
export const createWheelhouseEncounter = <ThrowOnError extends boolean = false>(
  options?: Options<CreateWheelhouseEncounterData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateWheelhouseEncounterResponses,
    CreateWheelhouseEncounterErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/encounters',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * show an encounter with its note
 */
export const wheelhouseEncounter = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseEncounterData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WheelhouseEncounterResponses,
    WheelhouseEncounterErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/encounters/{id}', ...options })

/**
 * autosave session metadata
 */
export const updateWheelhouseEncounter = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWheelhouseEncounterData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateWheelhouseEncounterResponses,
    UpdateWheelhouseEncounterErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/encounters/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * enhance the draft note into a SOAP suggestion with AI
 */
export const enhanceWheelhouseNote = <ThrowOnError extends boolean = false>(
  options: Options<EnhanceWheelhouseNoteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    EnhanceWheelhouseNoteResponses,
    EnhanceWheelhouseNoteErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/encounters/{encounter_id}/note_enhancement', ...options })

/**
 * list observations for a goal
 */
export const wheelhouseGoalObservations = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseGoalObservationsData, ThrowOnError>
) =>
  (options.client ?? client).get<WheelhouseGoalObservationsResponses, unknown, ThrowOnError>({
    url: '/v1/wheelhouse/goals/{goal_id}/observations',
    ...options,
  })

/**
 * log an observation
 */
export const createWheelhouseGoalObservation = <ThrowOnError extends boolean = false>(
  options: Options<CreateWheelhouseGoalObservationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateWheelhouseGoalObservationResponses,
    CreateWheelhouseGoalObservationErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/goals/{goal_id}/observations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * update an observation
 */
export const updateWheelhouseGoalObservation = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWheelhouseGoalObservationData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateWheelhouseGoalObservationResponses,
    UpdateWheelhouseGoalObservationErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/goals/{goal_id}/observations/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list a student's goals
 */
export const wheelhouseClientGoals = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseClientGoalsData, ThrowOnError>
) =>
  (options.client ?? client).get<WheelhouseClientGoalsResponses, unknown, ThrowOnError>({
    url: '/v1/wheelhouse/clients/{client_id}/goals',
    ...options,
  })

/**
 * create a goal
 */
export const createWheelhouseGoal = <ThrowOnError extends boolean = false>(
  options: Options<CreateWheelhouseGoalData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateWheelhouseGoalResponses, unknown, ThrowOnError>({
    url: '/v1/wheelhouse/clients/{client_id}/goals',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * fetch a goal
 */
export const wheelhouseGoal = <ThrowOnError extends boolean = false>(
  options: Options<WheelhouseGoalData, ThrowOnError>
) =>
  (options.client ?? client).get<WheelhouseGoalResponses, WheelhouseGoalErrors, ThrowOnError>({
    url: '/v1/wheelhouse/goals/{id}',
    ...options,
  })

/**
 * update a goal
 */
export const updateWheelhouseGoal = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWheelhouseGoalData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateWheelhouseGoalResponses,
    UpdateWheelhouseGoalErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/goals/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * list the provider's templates
 */
export const wheelhouseNoteTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<WheelhouseNoteTemplatesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    WheelhouseNoteTemplatesResponses,
    WheelhouseNoteTemplatesErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/note_templates', ...options })

/**
 * create a template
 */
export const createWheelhouseNoteTemplate = <ThrowOnError extends boolean = false>(
  options?: Options<CreateWheelhouseNoteTemplateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateWheelhouseNoteTemplateResponses,
    CreateWheelhouseNoteTemplateErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/note_templates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * archive (soft-delete) a template
 */
export const archiveWheelhouseNoteTemplate = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveWheelhouseNoteTemplateData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ArchiveWheelhouseNoteTemplateResponses,
    ArchiveWheelhouseNoteTemplateErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/note_templates/{id}', ...options })

/**
 * rename or edit a template
 */
export const updateWheelhouseNoteTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWheelhouseNoteTemplateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateWheelhouseNoteTemplateResponses,
    UpdateWheelhouseNoteTemplateErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/note_templates/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * add a note to an encounter
 */
export const createWheelhouseNote = <ThrowOnError extends boolean = false>(
  options: Options<CreateWheelhouseNoteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateWheelhouseNoteResponses,
    CreateWheelhouseNoteErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/encounters/{encounter_id}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * delete a draft note
 */
export const deleteWheelhouseNote = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWheelhouseNoteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteWheelhouseNoteResponses,
    DeleteWheelhouseNoteErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/encounters/{encounter_id}/notes/{id}', ...options })

/**
 * autosave a note's body
 */
export const updateWheelhouseNote = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWheelhouseNoteData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateWheelhouseNoteResponses,
    UpdateWheelhouseNoteErrors,
    ThrowOnError
  >({
    url: '/v1/wheelhouse/encounters/{encounter_id}/notes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * complete (attest) a note
 */
export const completeWheelhouseNote = <ThrowOnError extends boolean = false>(
  options: Options<CompleteWheelhouseNoteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CompleteWheelhouseNoteResponses,
    CompleteWheelhouseNoteErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/encounters/{encounter_id}/notes/{note_id}/completion', ...options })

/**
 * show the signed-in provider's identity and school
 */
export const wheelhouseSession = <ThrowOnError extends boolean = false>(
  options?: Options<WheelhouseSessionData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    WheelhouseSessionResponses,
    WheelhouseSessionErrors,
    ThrowOnError
  >({ url: '/v1/wheelhouse/session', ...options })
